import _ from "lodash";
import React from "react";
import update from "immutability-helper";
import { replace, push } from "services/NavigationService";
import moment from "moment-timezone";
import { ASSESSMENT_TOOLS } from "@toddle-edu/common-utils";
import {
  setToastMsg,
  getUserInfo,
  isToddleLibraryRoute,
} from "Login/modules/LoginModule";
import {
  goToBack,
  goToPlatformHomeFeatureRoute,
  updateQueryParameters,
} from "modules/NavigationModule";
import {
  getUnitPlanDetailsFromCache,
  writeUnitPlanFragment,
  writeUnitPlanFieldFragment,
} from "IBPlanner/modules/IBGraphqlHelpers";
import {
  generateFieldListFromTemplateFields,
  generateTemplateFieldQueryVariables,
  getUnitPlanFieldResponseFilter,
  isReflectionCreatedAtEditEnabled,
  getPlannerElementNodeFiltersMemoized,
  getElementValue,
} from "UnitPlans/modules/Utils";
import {
  initFilterObject,
  getFlatUnitPlanFeedQueryVariables,
  getUnitPlanFeedRefetchQueries,
  getFlatUnitPlanFeedV2QueryVariables,
  getLearningCourseUnitPlanFeedQueryVariables,
  getLearningCourseUnitPlanRefetchQueries,
  getUnitPlanFeedV2RefetchQueries,
  getPlannerFieldOptions,
  getPlannerFieldMutationParams,
  getPlannerFieldsOfNode,
  getFilteredPlannerElementNodeSets,
  getMergedPlannerElementNodeSets,
} from "UnitPlans/modules/UnitPlanModule";
import {
  generateRandomId,
  extractLabelsForTranslation,
  getRelativePath,
  getBilingualText,
  dispatchError,
  getArchivedSortedSubjectListMemoized,
  enhancedT,
} from "Utils";
import {
  writeUnitPlanV2Fragment,
  writeLearningCourseUnitPlanFragment,
  getLearningCourseUnitPlanFeedFromCache,
  getFlatFeedUnitPlansFromCache,
  getTemplateFieldsFromCache,
  getPlannerElementNodeSetIdsOfCurriculumFromCache,
  getPlannerElementNodeSetsFromIdsFromCache,
} from "UnitPlans/modules/UnitPlanGraphqlHelpers";
import {
  goToRelativeRoute,
  getVariablesForLocalisedPlannerTemplates,
} from "modules/Services";
import {
  checkEmptyElementValue,
  getResolvedOptimisticValue,
} from "modules/ElementValueUtils";
import {
  getUnitPlanCollaboratorsDetailsQuery,
  getUnitPlanQuery,
} from "./IBQuery";
import {
  createUnitPlanMutation,
  createUnitPlanMutationV2,
  updateUnitPlanMutation,
  createResponseMutation,
  deleteResponseMutation,
  editResponseMutation,
  addRelatedConceptMutation,
  updateUnitPlanSharingMutation,
  sendUnitPlanCollaboratorNotificationMutation,
} from "./IBMutations";
import { getPlannerElementTypesFromTemplate } from "./Utils";
import { recordEvent } from "lib/eventTracker";
import { plannerFieldFragment } from "UnitPlans/modules/UnitPlanFragments";
import {
  getOrganizationConstantsFromCache,
  getPlannerTemplateFromCache,
} from "modules/CommonGraphqlHelpers";
import client from "lib/apolloClient/client";
import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_UBD,
  GROUP_TYPE_WORKSHEET,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_DP,
  AI_TUTOR,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_UBD_SKILL,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_SYLLABUS,
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_KNOWLEDGE_FRAMEWORK,
  ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
  MOBILE_MEDIA_QUERY,
} from "Constants/stringConstants";
import {
  getFlatUnitPlanFeedQuery,
  getPlannerElementNodeSetsFromIdsQuery,
  getUnitPlanLockAndConflictFieldsQuery,
} from "UnitPlans/modules/UnitPlanQuery";
import {
  getPlannerElementNodeSetIdsOfCurriculumVariables,
  getPlannerElementNodeSetsFromIdsVariables,
} from "UnitPlans/modules/UnitPlanQueryEnhancers";

import {
  mapleBearLikeOrg,
  getUnitPlanCentralRepoInputAndFilters,
  decideUserLevelType,
} from "Courses/modules/utils";
import {
  getPropertyValue,
  isFieldPropertyPresent,
  BILINGUAL_TRANSLATION_PROPERTY_MAPPING,
} from "Fields/FieldUtils";
import ACLStore from "lib/aclStore";
import { updateAttachmentMutation } from "OrganizationResources/modules/OrganizationResourcesMutations";
import {
  createAttachmentMutation,
  deleteAttachmentMutation,
} from "modules/CommonMutations";
import {
  getSelectedAcademicYear,
  getSelectedAcademicYearId,
} from "modules/CommonSelectors";
import {
  ENABLE_ASSESSMENTS_IN_PYP,
  ENABLE_DYNAMIC_LOCALISATION_OF_TEMPLATE,
} from "Constants/permissionConstants";
import {
  getFieldListV2,
  getIconUrlFromKey,
  getIsStandardsField,
  getIsObjectivesField,
} from "UnitPlanDetails/routes/IBPlanner/modules/Utils";
import { isSinglePageAndNewUnitView } from "UnitPlans/modules/UnitViewModeUtils";
import { getSelectedLearningCourseId } from "LearningCourse/modules/Utils";
import {
  getIsLearningCoursesEnabled,
  getIsBlueprintCourse,
} from "LearningCourses/modules/Utils";
import { updateLockedStateMutation } from "UnitPlans/modules/LearningCourseFlow/UnitPlanLearningCourseMutation";
import {
  getAllPlannerElementTypesFromFields,
  getBaseCurriculumProgram,
} from "UnitPlans/modules/UnitPlanModule/UnitPlanUtils";

import { i18n } from "lib/i18n";
import { isNewPYPConceptsLabelEnabled } from "lib/i18nHelperVariables";
import { store } from "store/createStore";

Array.prototype.last = function () {
  return this[this.length - 1];
};

Array.prototype.first = function () {
  return this[0];
};
export const NAME = "planner";

export const CHANGE_CURRENT_STEP = "CHANGE_CURRENT_STEP" + " " + NAME;
export const CHANGE_CURRENT_MODULE_STEP =
  "CHANGE_CURRENT_MODULE_STEP" + " " + NAME;

export const SET_MIDDLE_PANE_SCROLL_TOP =
  "SET_MIDDLE_PANE_SCROLL_TOP" + " " + NAME;

export const RESET_SCROLL_CURRENT_MODULE_STEP =
  "RESET_SCROLL_CURRENT_MODULE_STEP" + " " + NAME;
export const SET_MODULE_ID = "SET_MODULE_ID" + " " + NAME;
export const UPDATE_RESPONSES = "UPDATE_RESPONSES" + " " + NAME;
export const UPDATE_UNIT_PLAN_IN_REDUX =
  "UPDATE_UNIT_PLAN_IN_REDUX" + " " + NAME;
export const UPDATE_COMMENT = "UPDATE_COMMENT" + " " + NAME;

export const RESET_UNIT_PLAN_DATA = "RESET_UNIT_PLAN_DATA" + " " + NAME;

export const UPDATE_EVIDENCE_SEARCH_TEXT =
  "UPDATE_EVIDENCE_SEARCH_TEXT" + " " + NAME;
export const UPDATE_EVIDENCE_FILTERS = "UPDATE_EVIDENCE_FILTERS" + " " + NAME;
export const TOGGLE_ACTION_LOADING = "TOGGLE_ACTION_LOADING" + " " + NAME;

export const SET_VIEW_STEP = "SET_VIEW_STEP" + " " + NAME;

export const UnitPlanDetailsContext = React.createContext();

export const UnitPlanFieldContext = React.createContext();

export const toggleActionLoading = data => {
  return {
    type: TOGGLE_ACTION_LOADING,
    data,
  };
};
export const changeCurrentStep = data => {
  return {
    type: CHANGE_CURRENT_STEP,
    data,
  };
};

export const changeCurrentModuleStep = data => {
  return {
    type: CHANGE_CURRENT_MODULE_STEP,
    data,
  };
};

export const setMiddlePaneScrollTop = data => {
  return {
    type: SET_MIDDLE_PANE_SCROLL_TOP,
    data,
  };
};

export const resetScrollCurrentModuleStep = data => {
  return {
    type: RESET_SCROLL_CURRENT_MODULE_STEP,
    data,
  };
};

export const updateCurrentViewStep = data => {
  return {
    type: SET_VIEW_STEP,
    data,
  };
};

export const setModuleId = data => {
  return {
    type: SET_MODULE_ID,
    data,
  };
};

export const resetUnitPlanData = data => {
  return {
    type: RESET_UNIT_PLAN_DATA,
    data,
  };
};

export const updateLocalResponses = data => {
  return {
    type: UPDATE_RESPONSES,
    data,
  };
};

export const updateUnitPlanInRedux = data => {
  return {
    type: UPDATE_UNIT_PLAN_IN_REDUX,
    data,
  };
};

export const getUnitPlanDetailsValueFromFieldKey = ({
  unitPlanDetails,
  mappedDetailsFields,
  key,
}) => {
  switch (key) {
    case "dateDuration": {
      return _.reduce(
        mappedDetailsFields,
        (result, val) => {
          result[val] = _.has(unitPlanDetails[val], "value")
            ? _.get(unitPlanDetails[val], "value", null)
            : unitPlanDetails[val];
          return result;
        },
        {}
      );
    }
    default:
      return null;
  }
};

export const isSubjectStandard = ({ type }) => {
  return _.includes(
    [
      ELEMENT_TYPE_DP_LEARNING_STANDARD,
      ELEMENT_TYPE_PYP_LEARNING_STANDARD,
      ELEMENT_TYPE_UBD_LEARNING_STANDARD,
      ELEMENT_TYPE_MYP_LEARNING_STANDARD,
    ],
    type
  );
};

const getUnitPlanTabs = ({
  t,
  modules,
  isCommunity,
  isToddleLibrary,
  unitFlowCount = 0,
  isLocalisedTemplate = true,
  module_list,
  localisedTemplateId,
  isDemo,
  userLevelType,
  isPreviewMode,
}) => {
  if (isCommunity || isToddleLibrary) {
    modules = _.filter(
      modules,
      item => !_.includes(["evidence", "reflection"], item)
    );

    // if (ACLStore.can("TeacherPortal:Community")) {
    modules = modules ?? [];
    // }
  }

  /**
   * if given organization is school groups and unit plan is imported from lib and user is
   * educator than remove modules specified in template
   * one can have general condition to remove modules as above
   */
  const condToRemoveModulesForSchoolGroups =
    mapleBearLikeOrg() &&
    _.includes(["global_team", "country_team"], userLevelType);
  if (condToRemoveModulesForSchoolGroups) {
    modules = _.filter(
      modules,
      item => !_.includes(["evidence", "reflection"], item)
    );
  }

  if (isDemo || isPreviewMode) {
    modules = _.filter(modules, item => !_.includes(["evidence"], item));
  }

  return _.map(modules, key => {
    const count = 0;

    let label = isLocalisedTemplate
      ? t(
          extractLabelsForTranslation({
            keys: ["unitPlan", localisedTemplateId, key, "label"],
          })
        )
      : _.get(module_list, `${key}.label`, "");

    // To solve following issue
    // https://toddle-edu.atlassian.net/browse/FRE-122?atlOrigin=eyJpIjoiOGZmM2YxMzhjNWFlNDU0OWJkNTcwNDE0MDZhNDVmZGMiLCJwIjoiaiJ9
    if (key === "comments" && label === "") {
      label = "Comments"; //TODO: Need to review this
    }

    return { label, value: key, count };
  });
};

export const getUnitPlanTabsMemoized = _.memoize(
  params => getUnitPlanTabs(params),
  params => JSON.stringify(params)
);

export const hasIncludeGivenPathInCurrentRoute = ({ path }) => {
  return _.includes(window.location.href, path);
};

export const goBackToPreviousScreen = ({ mode = "view" } = {}) => {
  return (dispatch, getState) => {
    //For unitplans,admin unitplans, community unit plans route - Because sometime they directly land to this page from email
    if (
      hasIncludeGivenPathInCurrentRoute({ path: "/adminunitplans" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/unitlibrary" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/school-library" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/community/home" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/unit-publishing" })
    ) {
      dispatch(
        goToRelativeRoute({
          route: "../",
          replacePath: mode,
        })
      );
    } else if (hasIncludeGivenPathInCurrentRoute({ path: "/unitPlans" })) {
      const currentViewType = getState().unitPlans.currentViewType;
      dispatch(
        goToRelativeRoute({
          route: `../${currentViewType}`,
          replacePath: mode,
        })
      );
    } else if (
      hasIncludeGivenPathInCurrentRoute({ path: "/planningInsights" })
    ) {
      dispatch(goToRelativeRoute({ route: "./", replacePath: "units" }));
    } else {
      dispatch(goToBack());
    }
  };
};
export const goBackToPreviousScreenV2 = () => {
  return (dispatch, getState) => {
    //For unitplans,admin unitplans, community unit plans route - Because sometime they directly land to this page from email
    if (
      hasIncludeGivenPathInCurrentRoute({ path: "/adminunitplans" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/unitlibrary" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/school-library" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/community/home" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/unit-publishing" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/course-flow" }) ||
      hasIncludeGivenPathInCurrentRoute({ path: "/course-plan" })
    ) {
      dispatch(
        goToRelativeRoute({
          route: "../../",
        })
      );
    } else if (hasIncludeGivenPathInCurrentRoute({ path: "/unitPlans" })) {
      const currentViewType = getState().unitPlans.currentViewType;
      dispatch(
        goToRelativeRoute({
          route: `../../${currentViewType}`,
        })
      );
    } else if (hasIncludeGivenPathInCurrentRoute({ path: "/unit" })) {
      const currentViewType = getState().learningCourse.currentCourseViewType;

      let route = `../../${currentViewType}`;
      if (!currentViewType) {
        route = "../../../course-flow";
      }

      dispatch(
        goToRelativeRoute({
          route,
        })
      );
    } else if (
      hasIncludeGivenPathInCurrentRoute({ path: "/planningInsights" })
    ) {
      dispatch(goToRelativeRoute({ route: "./", replacePath: "units" }));
    } else {
      dispatch(goToBack());
    }
  };
};

export const getUnitPlanCollaboratorsDetails = ({ id }) => {
  return async (dispatch, getState) => {
    const academicYearId = getSelectedAcademicYearId(getState());
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    await client.query({
      query: getUnitPlanCollaboratorsDetailsQuery,
      variables: {
        id,
        collaboratorsFilter,
      },
      fetchPolicy: "network-only",
    });
  };
};
export const addRelatedConcept = ({
  subjects,
  concepts,
  relatedConcepts,
  plannerElementSetId,
  plannerElementNodeSetId,
}) => {
  return async () => {
    try {
      const queryVariables = {
        plannerElementNodeSetIds: [plannerElementNodeSetId],
        plannerElementNodeFilters: {
          subjects,
          concepts,
        },
      };
      const result = await client.mutate({
        mutation: addRelatedConceptMutation,
        variables: {
          relatedConcepts,
          plannerElementSetId,
        },
        refetchQueries: [
          {
            query: getPlannerElementNodeSetsFromIdsQuery,
            variables: queryVariables,
          },
        ],
      });

      return _.get(result, "data.planner.addRelatedConcept", []);
    } catch (e) {
      return [];
    }
  };
};

export const updateUnitPlanInCache = ({
  fieldUID,
  params,
  fieldObj,
  extraParams,
  fieldTemplateObj,
}) => {
  return (dispatch, getState) => {
    const data = {
      ...fieldObj,
      value: params.value,
      resolvedMinimalTree: getResolvedOptimisticValue({
        resolvedValue: _.get(fieldObj, "resolvedMinimalTree", {}),
        fieldUID,
        fieldTemplateObj,
        params: extraParams,
        value: _.get(params, "value", ""),
      }),
    };

    client.writeFragment({
      id: `PlannerField:${params.id}`,
      fragment: plannerFieldFragment.unitplanField,
      fragmentName: "unitPlanFieldItem",
      data: data,
    });
  };
};

export const updateUnitPlanWithResponseFilterInCache = ({
  fieldUID,
  params,
  fieldObj,
  extraParams,
  fieldTemplateObj,
}) => {
  return () => {
    if (fieldUID === "image") return;
    const data = {
      ...fieldObj,
      value: params.value,
      resolvedMinimalTree: getResolvedOptimisticValue({
        resolvedValue: _.get(fieldObj, "resolvedMinimalTree", {}),
        fieldUID,
        fieldTemplateObj,
        params: extraParams,
        value: _.get(params, "value", ""),
      }),
    };

    const responseFilter = getUnitPlanFieldResponseFilter();

    client.writeFragment({
      id: `PlannerField:${params.id}`,
      fragment: plannerFieldFragment.unitPlanFieldWithResponseFilter,
      fragmentName: "unitPlanFieldItemWithResponseFilter",
      data: data,
      variables: {
        responseFilter,
      },
    });
  };
};
export const updateUnitPlanPlannerFieldInCache = ({
  fieldUID,
  params,
  fieldObj,
  extraParams,
  fieldTemplateObj,
}) => {
  return () => {
    if (fieldUID === "image") return;
    const data = {
      ...fieldObj,
      value: params.value,
      resolvedMinimalTree: getResolvedOptimisticValue({
        resolvedValue: _.get(fieldObj, "resolvedMinimalTree", {}),
        fieldUID,
        fieldTemplateObj,
        params: extraParams,
        value: _.get(params, "value", ""),
      }),
    };
    const responseFilter = getUnitPlanFieldResponseFilter();

    client.writeFragment({
      id: `PlannerField:${params.id}`,
      fragment: plannerFieldFragment.unitPlanFieldWithResponseFilterV2,
      fragmentName: "unitPlanFieldItemWithResponseFilter",
      data: data,
      variables: {
        responseFilter,
      },
    });
  };
};

export const updateMultipleUnitPlanFieldsInCache = fieldsToUpdate => {
  return () => {
    const responseFilter = getUnitPlanFieldResponseFilter();

    _.forEach(fieldsToUpdate, fieldUpdate => {
      const {
        fieldUID,
        params,
        fieldObj,
        extraParams,
        fieldTemplateObj,
      } = fieldUpdate;

      const data = {
        ...fieldObj,
        value: params.value,
        resolvedMinimalTree: getResolvedOptimisticValue({
          resolvedValue: _.get(fieldObj, "resolvedMinimalTree", {}),
          fieldUID,
          fieldTemplateObj,
          params: extraParams,
          value: _.get(params, "value", ""),
        }),
      };

      client.writeFragment({
        id: `PlannerField:${params.id}`,
        fragment: plannerFieldFragment.unitPlanFieldWithResponseFilterV2,
        fragmentName: "unitPlanFieldItemWithResponseFilter",
        data,
        variables: {
          responseFilter,
        },
      });
    });
  };
};

export const deleteResponse = ({ id, fieldId, fieldDetails }) => {
  return async dispatch => {
    const responses = fieldDetails.responses.edges;

    const updatedResponses = _.filter(responses, response => {
      return response.node.id !== id;
    });

    const responseUsersNode = {
      ...fieldDetails.responses,
      edges: updatedResponses,
      totalCount: fieldDetails.responses.totalCount - 1,
    };

    const responseFilter = getUnitPlanFieldResponseFilter();

    writeUnitPlanFieldFragment({
      fieldId,
      data: { ...fieldDetails, responses: responseUsersNode },
      responseFilter,
    });

    try {
      await client.mutate({
        mutation: deleteResponseMutation,
        variables: {
          id,
        },
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:deleted", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      console.error(e);
      writeUnitPlanFieldFragment({
        fieldId,
        data: fieldDetails,
        responseFilter,
      });
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const editResponse = ({
  id,
  initialPostIds,
  initialAttachmentIds,
  responseFieldData,
}) => {
  return async (dispatch, getState) => {
    const message = _.trim(_.get(responseFieldData, "message", ""));

    const fieldEvidence = _.get(responseFieldData, "evidence", []);

    let updatedAt;
    if (isReflectionCreatedAtEditEnabled()) {
      updatedAt = responseFieldData?.updatedAt;
    }

    // Handle posts
    const updatedPostList = _.filter(fieldEvidence, evidence =>
      _.has(evidence, "attachments")
    );

    const updatedPostIds = _.map(updatedPostList, _.iteratee("id"));

    const addedPosts = _.difference(updatedPostIds, initialPostIds);
    const removedPosts = _.difference(initialPostIds, updatedPostIds);

    // Handle attachments
    const updatedAttachmentList = _.filter(
      fieldEvidence,
      evidence => !_.has(evidence, "attachments")
    );

    const updatedAttachmentIds = _.map(updatedAttachmentList, _.iteratee("id"));

    const addedAttachments = _.map(
      _.filter(updatedAttachmentList, evidence =>
        _.includes(evidence.id, "NEW_")
      ),
      evidence => _.omit(evidence, ["id", "isPost", "attachmentId"])
    );
    const removedAttachments = _.difference(
      initialAttachmentIds,
      updatedAttachmentIds
    );

    try {
      await client.mutate({
        mutation: editResponseMutation,
        variables: {
          id,
          message,
          updatedAt,
          evidence: {
            addedPosts,
            removedPosts,
            addedAttachments,
            removedAttachments,
          },
        },
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:updated", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const createResponse = ({
  fieldId,
  fieldDetails,
  responseFieldData,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const message = _.trim(_.get(responseFieldData, "message", ""));
    let updatedAt;
    if (isReflectionCreatedAtEditEnabled()) {
      const currentDate = moment();
      updatedAt = responseFieldData?.updatedAt
        ? responseFieldData?.updatedAt
        : currentDate;
    }
    const fieldEvidence = _.get(responseFieldData, "evidence", []);
    if (!message && _.isEmpty(fieldEvidence)) {
      dispatch(setToastMsg("toastMsgs:couldnt_be_added"));
      return;
    }

    // Handle new Posts and Attachments
    const addedPosts = _.map(
      _.filter(fieldEvidence, evidence => evidence.isPost),
      _.iteratee("id")
    );
    const addedAttachments = _.map(
      _.filter(fieldEvidence, evidence => !evidence.isPost),
      evidence => _.omit(evidence, ["id", "isPost", "attachmentId"])
    );

    try {
      await client.mutate({
        mutation: createResponseMutation,
        variables: {
          fieldId,
          message,
          updatedAt,
          evidence: {
            addedPosts,
            addedAttachments,
          },
          createdBy: userInfo.id,
        },
        update: (
          cache,
          {
            data: {
              planner: { addResponseToField },
            },
          }
        ) => {
          const data = {
            ...fieldDetails,
            responses: addResponseToField,
          };

          const responseFilter = getUnitPlanFieldResponseFilter();

          writeUnitPlanFieldFragment({
            fieldId,
            data,
            responseFilter,
          });
        },
      });
      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:added", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

// to delete individual attachment in reflections
export const deleteAttachments = ({ attachmentIds, id, responseId }) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: deleteAttachmentMutation,
        variables: {
          attachmentIds,
        },
        update: cache => {
          // Only update cache if mutation succeeded
          const data = cache.readFragment({
            id: `PlannerField:${id}`,
            fragment: plannerFieldFragment.unitPlanFieldResponses,
            fragmentName: "unitPlanFieldItem",
          });

          if (!_.get(data, "responses.edges")) {
            return; // Skip cache update if data structure is invalid
          }

          const updatedData = _.cloneDeep(data);

          if (responseId) {
            const responseIndex = _.findIndex(
              updatedData.responses.edges,
              edge => edge.node.id === responseId
            );

            if (responseIndex !== -1) {
              const edge = updatedData.responses.edges[responseIndex];
              const evidence = _.get(edge, "node.evidence", []);
              const updatedEvidence = _.filter(
                evidence,
                evidenceItem => !_.includes(attachmentIds, evidenceItem.id)
              );

              // Only update if evidence array changed
              if (updatedEvidence.length !== evidence.length) {
                updatedData.responses.edges[responseIndex] = _.set(
                  _.cloneDeep(edge),
                  "node.evidence",
                  updatedEvidence
                );

                // Write the updated data to cache
                cache.writeFragment({
                  id: `PlannerField:${id}`,
                  fragment: plannerFieldFragment.unitPlanFieldResponses,
                  fragmentName: "unitPlanFieldItem",
                  data: updatedData,
                });
              }
            }
          }
        },
      });

      dispatch(
        setToastMsg({
          type: "success",
          msg: "toastMsgs:successfully_with_label",
          locale_params: [
            { key: "label", value: "toastMsgs:deleted", isPlainText: false },
          ],
        })
      );
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      throw e;
    }
  };
};

export const getResourceTypes = ({ curriculumType = "IB_PYP" }) => {
  return (dispatch, getState) => {
    let resourcesTypes = [
      {
        key: "ASSESSMENT",
        label: "assessment_with_count",
        labelWithoutCount: "assessment_label",
        type: "ASSESSMENT",
        pluralText: "Assessments",
      },
      {
        key: "LEARNING_ENGAGEMENT",
        label: "le_with_count",
        labelWithoutCount: "le_label",
        type: "LEARNING_ENGAGEMENT",
        pluralText: "Learning Experiences",
      },
      {
        key: "WORKSHEET",
        label: "worksheet",
        labelWithoutCount: "worksheet",
        type: GROUP_TYPE_WORKSHEET,
        pluralText: "Worksheets",
      },
      {
        key: AI_TUTOR,
        label: "ai_tutor_with_count",
        labelWithoutCount: "ai_tutor",
        type: AI_TUTOR,
        pluralText: "AI tutor",
      },
    ];

    if (curriculumType == "IB_PYP") {
      resourcesTypes = [
        {
          key: "ASSESSMENT",
          label: "le_with_count",
          labelWithoutCount: "le_label",
          type: "LEARNING_ENGAGEMENT",
          pluralText: "Learning Experiences",
        },
        {
          key: "WORKSHEET",
          label: "worksheet",
          labelWithoutCount: "worksheet",
          type: GROUP_TYPE_WORKSHEET,
          pluralText: "Worksheets",
        },
        {
          key: AI_TUTOR,
          label: "ai_tutor_with_count",
          labelWithoutCount: "ai_tutor",
          type: AI_TUTOR,
          pluralText: "AI tutor",
        },
      ];
    }

    return resourcesTypes;
  };
};

export const getResourceTypeItem = params => {
  const { resources, curriculumType, groupType } = params;

  const key =
    curriculumType == "IB_PYP"
      ? _.includes([GROUP_TYPE_WORKSHEET, AI_TUTOR], groupType)
        ? groupType
        : "ASSESSMENT"
      : groupType;

  return _.find(resources, { key });
};

//this function append key of isLock in given step_list and field_list data
export const lockFields = ({
  step_list,
  lockField = [],
  updatedStepField,
  updatedFieldList,
  updatedFieldListV2,
}) => {
  const isPermLockField = _.some(lockField, "perm");

  if (!isPermLockField) {
    //if every field in step is locked then only lock the that particular step
    _.forEach(step_list, (step, stepKey) => {
      let lockFieldForSchoolGroups = true;

      const fields = _.get(updatedStepField[stepKey], "fields", []);

      _.forEach(fields, field => {
        lockFieldForSchoolGroups &= _.includes(lockField, field);
      });

      //update step list those are available in steps list
      updatedStepField[stepKey] = {
        ...step,
        lockFieldForSchoolGroups,
      };
    });

    //lock all fields which has been specified in the template
    _.forEach(lockField, field => {
      const isPortedField = _.has(updatedFieldListV2, field);
      if (isPortedField) {
        updatedFieldListV2[field] = {
          ...updatedFieldListV2[field],
          lockFieldForSchoolGroups: { value: true },
        };
      } else {
        const fieldData = updatedFieldList[field];
        const config = _.get(fieldData, "config", {});
        updatedFieldList[field] = {
          ...fieldData,
          config: {
            ...config,
            lockFieldForSchoolGroups: true,
          },
        };
      }
    });
  }
  // code executes if the templates has lockfield Perm objs
  else {
    _.forEach(step_list, (step, stepKey) => {
      let lockFieldForSchoolGroups = true;

      const fields = _.get(updatedStepField[stepKey], "fields", []);

      _.forEach(fields, field => {
        const lockObj = _.find(lockField, ["field", field]);
        lockFieldForSchoolGroups &=
          lockObj && ACLStore.can(_.get(lockObj, "perm"));
      });

      //update step list those are available in steps list
      updatedStepField[stepKey] = {
        ...step,
        lockFieldForSchoolGroups,
      };
    });

    //lock all fields which has been specified in the template lock perm
    _.forEach(lockField, ({ perm, field }) => {
      const isPortedField = _.has(updatedFieldListV2, field);
      if (isPortedField) {
        updatedFieldListV2[field] = {
          ...updatedFieldListV2[field],
          lockFieldForSchoolGroups: { value: ACLStore.can(perm) },
        };
      } else {
        const fieldData = updatedFieldList[field];
        const config = _.get(fieldData, "config", {});
        updatedFieldList[field] = {
          ...fieldData,
          config: {
            ...config,
            lockFieldForSchoolGroups: ACLStore.can(perm),
          },
        };
      }
    });
  }
};

const updateFieldListForBilingual = ({ fieldList }) => {
  _.forEach(Object.keys(fieldList), field => {
    if (_.has(fieldList[field], "config.bilingualConfig")) {
      const bilingualConfig = _.get(
        fieldList[field],
        "config.bilingualConfig",
        {}
      );
      const fieldConfig = ["label", "subtext", "placeholder"];
      _.forEach(fieldConfig, property => {
        if (_.has(bilingualConfig, property)) {
          fieldList[field] = update(fieldList[field], {
            config: {
              [property]: text =>
                getBilingualText({
                  text,
                  bilingualText: _.get(
                    fieldList[field],
                    `config.bilingualConfig.${property}`,
                    ""
                  ),
                }),
            },
          });
        }
      });
      if (_.has(bilingualConfig, "promptLabel")) {
        fieldList[field] = update(fieldList[field], {
          config: {
            promptsConfig: {
              label: label =>
                getBilingualText({
                  text: label,
                  bilingualText: _.get(
                    fieldList[field],
                    "config.bilingualConfig.promptLabel",
                    ""
                  ),
                  skipDelimiter: true,
                }),
            },
          },
        });
      }

      // Merging properties inside fieldTypeConfig
      const fieldTypeConfig = ["startDateLabel", "endDateLabel"];
      _.forEach(fieldTypeConfig, property => {
        if (_.has(bilingualConfig, property)) {
          fieldList[field] = update(fieldList[field], {
            config: {
              fieldTypeConfig: {
                [property]: text =>
                  getBilingualText({
                    text,
                    bilingualText: _.get(bilingualConfig, property),
                  }),
              },
            },
          });
        }
      });
    }
  });
  return fieldList;
};

const updateFieldListV2ForBilingual = ({ fieldList }) => {
  let updatedFieldList = { ...fieldList };

  const fieldKeys = _.keys(fieldList);
  const properties = _.keys(BILINGUAL_TRANSLATION_PROPERTY_MAPPING);

  _.forEach(fieldKeys, fieldKey => {
    const fieldObj = updatedFieldList[fieldKey];

    _.forEach(properties, property => {
      const propertyValue = getPropertyValue({
        fieldObj,
        propertyPath: property,
      });

      if (isFieldPropertyPresent({ fieldObj, propertyPath: property })) {
        const bilingualPropertyValue = getPropertyValue({
          fieldObj,
          propertyPath: BILINGUAL_TRANSLATION_PROPERTY_MAPPING[property],
        });

        // Combining property and bilingual property text
        updatedFieldList = update(updatedFieldList, {
          [fieldKey]: {
            [property]: {
              value: {
                $set: getBilingualText({
                  text: propertyValue,
                  bilingualText: bilingualPropertyValue,
                  skipDelimiter: property === "promptsLabel",
                }),
              },
            },
          },
        });
      }
    });
  });

  return updatedFieldList;
};

const updateOtherListForBilingual = ({ list }) => {
  _.forEach(Object.keys(list), item => {
    if (_.get(list[item], "isDisciplinary", false)) {
      return list;
    }
    if (list[item].bilingualConfig) {
      const bilingualConfig = _.get(list[item], "bilingualConfig", {});
      const itemConfig = ["label", "subtext"];
      _.forEach(itemConfig, property => {
        if (_.has(bilingualConfig, property)) {
          list[item] = update(list[item], {
            [property]: text =>
              getBilingualText({
                text: text,
                bilingualText: _.get(bilingualConfig, property, ""),
              }),
          });
        }
      });
    }
  });
  return list;
};

const _updateFieldListForMultiWindowTableHelper = ({
  fieldList,
  fieldKey,
  subFieldIndex,
}) => {
  return update(fieldList, {
    [fieldKey]: {
      subFields: {
        [subFieldIndex]: {
          config: {
            isFilteredByFieldPorted: {
              $set: true,
            },
          },
        },
      },
    },
  });
};

const _updateFieldListForMultiWindowTable = ({ fieldList, fieldListV2 }) => {
  let updatedFieldList = fieldList;
  const fieldKeys = _.keys(updatedFieldList);

  _.forEach(fieldKeys, fieldKey => {
    const fieldObj = updatedFieldList[fieldKey];
    const { type } = fieldObj;

    if (type === "MultiWindowTable") {
      const subFields = _.get(fieldObj, "subFields", []);

      _.forEach(subFields, (subFieldObj, subFieldIndex) => {
        const filteredBy = _.get(subFieldObj, "config.filteredBy[0]");

        if (_.has(fieldListV2, filteredBy)) {
          updatedFieldList = _updateFieldListForMultiWindowTableHelper({
            fieldList: updatedFieldList,
            fieldKey,
            subFieldIndex,
          });
        }
      });
    }
  });

  return updatedFieldList;
};

const ASSESSMENT_LIBRARY = "ASSESSMENT_LIBRARY";

const updatedModuleListForStage = ({ updatedModuleList, updatedModules }) => {
  if (!updatedModules.length) return updatedModuleList;

  const firstModuleKey = updatedModules[0];
  const module = updatedModuleList[firstModuleKey];

  if (!module?.stages?.length) return updatedModuleList;

  const [firstStage, ...otherStages] = module.stages;
  const [firstDraftStage, ...otherDraftStages] = module.draft_stages || [];

  return {
    ...updatedModuleList,
    [firstModuleKey]: {
      ...module,
      stages: [`${firstStage}_V2`, firstStage, ...otherStages],
      draft_stages: firstDraftStage
        ? [`${firstDraftStage}_V2`, firstDraftStage, ...otherDraftStages]
        : [],
    },
  };
};

const FIELD_TYPES_FOR_GENERIC_CARDS = [
  "IBMultiSelect",
  "IBTheme",
  "MultiSelect",
  "MultiSelectWithIcon",
  "MultiSelectWithImage",
  "UIInputCheckList",
];

const MULTI_SELECT_FIELD_TYPES_FOR_GENERIC_CARDS = [
  "MultiSelect",
  "IBMultiSelect",
  "MultiSelectWithImage",
  "UIInputCheckList",
];

const FIELDS_TO_EXCLUDE_FOR_GENERIC_CARDS = [
  "subjects",
  "subjectLevel",
  "focusAreas",
  "conceptsMYP",
  "cpFrameworkIntersections",
  "languageLearningDP",
  "focusAreasUBD",
];

const FIELD_TYPES_FOR_GENERIC_CHECKLIST = [
  "IBMultiSelect",
  // "NestedSelectComponent",
  // "InputNumberList",
  "IBConcepts",
  "NestedCheckList",
  "CheckList",
];

const FIELDS_TO_INCLUDE_FOR_GENERIC_CHECKLIST = [
  "conceptsMYP",
  "cpFrameworkIntersections",
  "languageLearningDP",
  "focusAreasUBD",
];

const FIELD_TO_SUBFIELD_MAP = {
  concepts: {
    subField: {
      uid: "conceptsQuestion",
      config: {
        textboxPlaceholder:
          "Explain how this concept will be used and why you have chosen it for your Unit of Inquiry",
        textboxUid: "q1",
      },
    },
  },
  action: {
    subField: {
      uid: "actionQuestion",
      config: {
        textboxPlaceholder:
          "Explain why have you chosen this action type for your unit and how will you make space for student action?",
        textboxUid: "q1",
      },
    },
  },
};

const QUESTIONS_FIELDS = ["conceptsQuestion", "actionQuestion"];

const FIELD_TYPES_FOR_GENERIC_LIST_VIEW = [
  "IBSkills",
  "IBBenchmarks",
  "NestedSelectComponent",
];

const PLANNER_ELEMENT_TYPES_FOR_DATAGRID = [
  ELEMENT_TYPE_PYP_ATL,
  ELEMENT_TYPE_PYP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_OBJECTIVES,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_UBD_SKILL,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_DP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_SYLLABUS,
  ELEMENT_TYPE_DP_KNOWLEDGE_FRAMEWORK,
  ELEMENT_TYPE_MYP_RELATED_CONCEPT,
  ELEMENT_TYPE_MYP_SPECIFIED_CONCEPT,
];
const MULTI_COLUMN_FIELDS = [
  "conceptsMYP",
  "languageLearningDP",
  "tokConnectionDP",
];

const SHOW_SUBTEXT_AS_INFO_FIELDS = ["globalContextMYP"];

const getEmptyTextForDataGridFields = ({
  type,
  isCourseBasedGradingEnabled,
  isLearningCoursesEnabled,
  t,
}) => {
  const isStandardsField = getIsStandardsField({
    plannerElementType: type,
  });

  const isObjectivesField = getIsObjectivesField({
    plannerElementType: type,
  });

  if (isObjectivesField) {
    return t("unitPlan:add_subject_groups_to_objectives");
  }

  return isStandardsField
    ? isCourseBasedGradingEnabled
      ? null
      : isLearningCoursesEnabled
      ? t("unitPlan:add_standards_disabled_text")
      : t("unitPlan:add_subject_standards_disabled_text")
    : "";
};

const getUpdatedSinglePageUnitPlanFields = ({
  fieldList,
  shouldUpdateViewTypeInSinglePage = true,
  t,
  isLearningCoursesEnabled,
  isCourseBasedGradingEnabled,
  stepList,
  isMYPInterdisciplinary,
  skipTemplateUpdateForToddleLibrary,
}) => {
  if (
    (!isSinglePageAndNewUnitView() && !isDisplayNewFieldsInOldViewEnabled()) ||
    skipTemplateUpdateForToddleLibrary
  ) {
    return fieldList;
  }
  const unitDetailsStep = _.get(stepList, "UNIT_DETAILS");

  return _.transform(
    fieldList,
    (updatedFieldList, fieldObj, fieldKey) => {
      const { type } = fieldObj;
      const fieldTypeConfig = _.get(fieldObj, "config.fieldTypeConfig", {});
      const isFieldInDetailsStep = _.includes(
        unitDetailsStep?.fields,
        fieldKey
      );
      const isGroupedOptions =
        _.get(fieldTypeConfig, "isGroupedOptions", false) ||
        _.isEqual(type, "NestedCheckList");

      if (
        !_.includes(FIELDS_TO_EXCLUDE_FOR_GENERIC_CARDS, fieldKey) &&
        _.includes(FIELD_TYPES_FOR_GENERIC_CARDS, type) &&
        !isGroupedOptions
      ) {
        const allowMultiSelect = _.includes(
          MULTI_SELECT_FIELD_TYPES_FOR_GENERIC_CARDS,
          type
        );
        const isUpdateActionsAllowed = type === "UIInputCheckList";
        const viewType = shouldUpdateViewTypeInSinglePage
          ? "GenericCardList"
          : _.get(fieldObj, "viewType", type);
        // the options logic should always remain in updateTemplate as we want to use
        // a function to get the icons
        let options = _.get(fieldObj, "config.options", []);
        if (_.isEqual(type, "MultiSelectWithImage")) {
          options = _.map(options, option => {
            return {
              ...option,
              icon: getIconUrlFromKey({ iconKey: option.image }),
            };
          });
        }
        updatedFieldList[fieldKey] = {
          ...fieldObj,
          type: "GenericCardList",
          viewType,
          config: {
            ...fieldObj.config,
            fieldTypeConfig: {
              ...fieldTypeConfig,
              allowMultiSelect,
              isUpdateActionsAllowed,
              ...(_.includes(SHOW_SUBTEXT_AS_INFO_FIELDS, fieldKey)
                ? { showSubtextUnderInfo: true }
                : {}),
              totalColumns: type === "IBTheme" ? 3 : 2,
            },
            ...(_.isEmpty(options) ? {} : { options }),
          },
        };
      }

      //  isGroupedOptions: there are certain fields inside multiselect which we have to consider.
      else if (
        !(_.isEqual(type, "IBConcepts") && !shouldUpdateViewTypeInSinglePage) &&
        (_.includes(FIELD_TYPES_FOR_GENERIC_CHECKLIST, type) ||
          isGroupedOptions ||
          _.includes(FIELDS_TO_INCLUDE_FOR_GENERIC_CHECKLIST, fieldKey))
      ) {
        const showTextBoxOnSelect = _.isEqual(type, "IBConcepts");

        // case specifically written for key concepts of MYP where we create parent nodes manually (majorly in subject specific templates)
        // so we need to filter parent nodes on update as well to prevent it from updating in resolvedMinimalTree
        const shouldFilterParentNodesOnUpdate =
          _.isEqual(fieldKey, "conceptsMYP") && isGroupedOptions;

        const subFieldObj = _.get(FIELD_TO_SUBFIELD_MAP, fieldKey, {});
        let isDependentField = false;
        if (fieldKey === "focusAreas") {
          isDependentField = true;
        }

        const viewType = shouldUpdateViewTypeInSinglePage
          ? "GenericCheckList"
          : _.get(fieldObj, "viewType", type);

        updatedFieldList[fieldKey] = {
          ...fieldObj,
          config: {
            ...fieldObj.config,
            fieldTypeConfig: {
              ...fieldTypeConfig,
              showTextBoxOnSelect,
              isGroupedOptions,
              ...(isDependentField && { isDependentField }),
              ...(shouldFilterParentNodesOnUpdate && {
                shouldFilterParentNodesOnUpdate,
              }),
              ...(_.includes(MULTI_COLUMN_FIELDS, fieldKey)
                ? { isMultiColumn: true }
                : {}),
            },
          },
          ...subFieldObj,
          type: "GenericCheckList",
          viewType,
        };
      } else if (_.includes(FIELD_TYPES_FOR_GENERIC_LIST_VIEW, type)) {
        let updatedType = type;
        let updatedPlannerElementConfig = _.get(
          fieldObj,
          "config.plannerElementConfig",
          {}
        );
        const { type: plannerElementType } = updatedPlannerElementConfig;

        const label =
          isMYPInterdisciplinary && fieldObj.dynamicSubject
            ? _.get(fieldObj, "config.label", "")
            : _.get(
                getCurrentPlannerElementSetFromState(plannerElementType)(
                  store.getState()
                ),
                "label"
              ) ?? _.get(fieldObj, "config.label", "");

        // Used for showing empty text if it's dependent on other field
        // and the other field is not selected
        let dependentFieldEmptyText = _.get(fieldObj, "config.emptyText");
        const emptyText = _.get(fieldObj, "config.emptyText");
        if (
          _.includes(
            PLANNER_ELEMENT_TYPES_FOR_DATAGRID,
            updatedPlannerElementConfig?.type
          )
        ) {
          updatedType = "PlannerElementDataSet";
          dependentFieldEmptyText =
            getEmptyTextForDataGridFields({
              type: updatedPlannerElementConfig?.type,
              isCourseBasedGradingEnabled,
              isLearningCoursesEnabled,
              t,
            }) || emptyText;

          updatedPlannerElementConfig = {
            ...fieldTypeConfig,
            // required as we are combining all different node boxes into single modal
            showEditButtonAtHeader: true,
          };
        }
        const viewType = shouldUpdateViewTypeInSinglePage
          ? updatedType
          : _.get(fieldObj, "viewType", updatedType);

        updatedFieldList[fieldKey] = {
          ...fieldObj,
          config: {
            ...fieldObj.config,
            label,
            fieldTypeConfig: updatedPlannerElementConfig,
            dependentFieldEmptyText,
          },
          viewType,
          type: updatedType,
        };
      } else if (type === "InputNumberList") {
        let isDependentField = false;
        if (fieldKey === "explorationDevelopMYP") {
          isDependentField = true;
        }
        updatedFieldList[fieldKey] = {
          ...fieldObj,
          viewType: "InputNumberList",
          config: {
            ...fieldObj.config,
            fieldTypeConfig: {
              ...fieldTypeConfig,
              dsVersion: "2.0",
              showSeparator: false,
              ...(isDependentField && { isDependentField }),
            },
          },
        };
      } else if (type === "SubjectGroupSubjectViewOnly") {
        updatedFieldList[fieldKey] = {
          ...fieldObj,
          viewType: "SubjectViewOnly",
          type: "SubjectViewOnly",
        };
      } else if (type === "TextArea" && !isFieldInDetailsStep) {
        updatedFieldList[fieldKey] = {
          ...fieldObj,
          viewType: "TextView",
          type: "RichText",
        };
      } else {
        updatedFieldList[fieldKey] = fieldObj;
      }
    },
    {}
  );
};

const updateFieldListV2ForSinglePage = (
  fieldListV2,
  skipTemplateUpdateForToddleLibrary
) => {
  if (
    (!isSinglePageAndNewUnitView() && !isDisplayNewFieldsInOldViewEnabled()) ||
    skipTemplateUpdateForToddleLibrary
  )
    return fieldListV2;

  return _.mapValues(fieldListV2, fieldObj => {
    const uiTypeVal = _.get(fieldObj, "uiType.value");
    const updatedField = _.cloneDeep(fieldObj);

    switch (uiTypeVal) {
      case "NESTED_CHECKLIST": {
        const showEditButtonAtHeaderObj = {
          id: "",
          value: true,
        };
        // For other field types, set the uiType value to the original value
        // _.set(updatedField, "uiType.value", uiTypeVal);
        _.set(
          updatedField,
          "showEditButtonAtHeader",
          showEditButtonAtHeaderObj
        );
        break;
      }
      case "TextArea": {
        _.set(updatedField, "uiType.value", "RichText");
        break;
      }
    }
    return updatedField;
  });
};

const getUpdatedSinglePageUnitPlanStepList = ({
  stepList,
  skipTemplateUpdateForToddleLibrary,
}) => {
  if (
    (!isSinglePageAndNewUnitView() && !isDisplayNewFieldsInOldViewEnabled()) ||
    skipTemplateUpdateForToddleLibrary
  ) {
    return stepList;
  }

  return _.transform(
    stepList,
    (updatedStepList, stepObj, stepKey) => {
      const fields = _.get(stepObj, "fields", []);
      const draftFields = _.get(stepObj, "draft_fields", []);

      updatedStepList[stepKey] = {
        ...stepObj,
        fields: _.difference(fields, QUESTIONS_FIELDS),
        draft_fields: _.difference(draftFields, QUESTIONS_FIELDS),
      };
    },
    {}
  );
};

//generic selector for getting current planner element set from state
//made in this way to maintain compatablity with connect and useReduxState
const getCurrentPlannerElementSetFromState = elementType => state => {
  const currentPlannerElementSets = _.get(
    state,
    "platform.currentPlannerElementSets",
    {}
  );

  const plannerElementSet = currentPlannerElementSets[elementType] || {};

  return plannerElementSet;
};

export const getElementTypeLabels = ({ t, type, subject }) => {
  const state = store.getState();
  const isSubjectStandardType = isSubjectStandard({ type });
  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

  // Only get label from planner element set if it's a subject standard AND learning courses are enabled
  if (isSubjectStandardType && isLearningCoursesEnabled) {
    const { label } = getCurrentPlannerElementSetFromState(type)(state);
    const fieldLabel = _.includes(["Standards", undefined], label)
      ? t("common:standard_plural")
      : label;

    return subject ? `${subject} ${fieldLabel}` : fieldLabel;
  }
  return null;
};

const updateFieldListForLearningCourse = ({
  t,
  updateFieldList,
  isCourseBasedGradingEnabled,
  isGlobal,
}) => {
  const fieldList = updateFieldList?.["learningStandardUBD"];

  if (!fieldList) return updateFieldList;

  const { label } = getCurrentPlannerElementSetFromState(
    ELEMENT_TYPE_UBD_LEARNING_STANDARD
  )(store.getState());

  const fieldLabel = _.includes(["Standards", undefined], label)
    ? t("common:standard_plural")
    : label;

  const fieldconfig = {
    ...fieldList,
    config: {
      ...(fieldList?.config || {}),
      label: fieldLabel,
      skipLocalisation: true,
      subtext: isGlobal
        ? t(
            "unitPlanTemplate:unitPlan_ubdUnitPlan_learningStandardUBD_subtext_learningCourse"
          )
        : _.get(fieldList, "config.subtext", ""),
      fieldTypeConfig: {
        ...(fieldList?.config?.fieldTypeConfig || {}),
      },
    },
  };
  updateFieldList = { ...updateFieldList, learningStandardUBD: fieldconfig };

  if (isCourseBasedGradingEnabled) {
    const filteredFieldList = _.omit(updateFieldList, "subjects");
    return { ...filteredFieldList };
  }
  return { ...updateFieldList };
};

const updateStepListForLearningCourse = ({ updatedStepList, t }) => {
  const stepList = updatedStepList["SLO"];
  if (!stepList) return updatedStepList;
  const { label } = getCurrentPlannerElementSetFromState(
    ELEMENT_TYPE_UBD_LEARNING_STANDARD
  )(store.getState());
  const stepLabel = _.includes(["Standards", undefined], label)
    ? t("common:standard_plural")
    : label;

  const stepConfig = {
    ...stepList,
    label: stepLabel,
    skipLocalisation: true,
  };
  updatedStepList = { ...updatedStepList, SLO: stepConfig };
  return { ...updatedStepList };
};

const updateFieldConfigurations = ({
  fieldList,
  updateFieldList,
  curriculumType,
  t,
}) => {
  const isMobileMediaQuery = matchMedia(MOBILE_MEDIA_QUERY);
  const isMobile = isMobileMediaQuery.matches;
  const titlePlaceHolder = _.get(
    fieldList,
    "title.config.label",
    t("unitPlan:unit_title")
  );

  const fieldConfigMap = {
    image: {
      config: {
        styles: {
          style: {
            padding: "0 0 16px 0",
          },
        },
      },
      type: "ImageCoverUpload",
      viewType: "ImageCoverUpload",
    },
    title: {
      skipLocalisation: true,
      config: {
        placeholder: titlePlaceHolder,
        fieldTypeConfig: {
          error: t("unitPlan:please_enter_title_error"),
          emptyText: t("common:untitled"),
          textStyle: {
            fontSize: "3.2rem",
            fontWeight: "700",
            lineHeight: "4.4rem",
            color: "#222",
          },
          textAreaStyles: {
            fontSize: "3.2rem",
            fontWeight: "700",
            lineHeight: "4.4rem",
            border: "none",
            padding: "0px",
            backgroundColor: "transparent",
            color: "#222",
          },
          minRows: 1,
          showMaxLength: false,
          // useControlledInput and shouldSyncLocalStateWithInput are for ControlledInputWrapper
          // useControlledInput stores the value in local state to prevent cursor from jumping
          // shouldSyncLocalStateWithInput syncs the local state with the input value for realtime updates
          useControlledInput: true,
          shouldSyncLocalStateWithInput: true,
        },
        icon: "PageSquareOutlined",
      },
      type: "TextArea",
    },
    subtitle: {
      skipLocalisation: true,
      config: {
        label: t("unitPlan:subtitle"),
        placeholder: t("unitPlan:enter_subtitle"),
        fieldTypeConfig: {
          textAreaStyles: {
            fontSize: "14px",
            lineHeight: "20px",
            border: "none",
            padding: "0px",
            paddingLeft: "16px",
            backgroundColor: "transparent",
            color: "#333333",
          },
          minRows: 1,
          showMaxLength: false,
          emptyText: t("common:not_selected"),
          shouldRegisterLabelContainerRef: true,
          containerStyle: {
            gap: "0px",
            flexDirection: "row",
            alignItems: "center",
          },
          labelContainerStyle: {
            width: "240px",
            margin: "0px",
          },
          editContainerStyle: {
            // Specifically applied here 8px instead of 16px as, if we won't do this then we might have to convert whole updateTemplate with
            // edit and view mode dependency
            paddingLeft: "8px",
            paddingRight: "8px",
            paddingTop: "6px",
            paddingBottom: "6px",
          },
          // useControlledInput and shouldSyncLocalStateWithInput are for ControlledInputWrapper
          // useControlledInput stores the value in local state to prevent cursor from jumping
          // shouldSyncLocalStateWithInput syncs the local state with the input value for realtime updates
          useControlledInput: true,
          shouldSyncLocalStateWithInput: true,
        },
        icon: "SpiralBookLines",
        allowComment: false,
      },
      type: "TextArea",
    },
    dateDuration: {
      config: {
        label: "",
        isLearningGoal: true,
        showReflection: false,
        fieldTypeConfig: {
          endDateLabel: t("common:end_date"),
          startDateLabel: t("common:start_date"),
          labelContainerStyle: {
            width: "240px",
            margin: "0px",
          },
          shouldRegisterLabelContainerRef: true,
        },
        mappedDetailsFields: ["startDate", "endDate"],
        isRequiredToCreateUnit: true,
        isMappedWithDetailsFields: true,
      },
      type: "DateDurationSelectorV2",
      viewType: "DateDurationSelectorV2",
    },
    subjectLevel: {
      id: "subjectLevel",
      type: "FieldDropdown",
      viewType: "FieldDropdown",
      skipLocalisation: true,
      config: {
        icon: "HamburgerOutlined",
        label: t("unitPlan:levels"),
        subText: "",
        viewLabel: t("unitPlan:levels"),
        fieldTypeConfig: {
          error: t("unitPlan:please_select_subject_level_error"),
          multi: true,
          placeholder: t("common:select"),
          tickPosition: "top",
          useListStyle: "grid",
          activeTickColor: "#008392",
          listContainerStyle: {
            maxWidth: "fit-content",
          },
          showSubtextUnderInfo: true,
          isMultiSelectComponentV2: true,
          emptyText: t("common:not_selected"),
          textStyle: {
            paddingLeft: "16px",
          },
          shouldRegisterLabelContainerRef: true,
          containerStyle: isMobile
            ? { gap: "4px", flexDirection: "column" }
            : {
                gap: "0px",
                flexDirection: "row",
                alignItems: "center",
              },
          labelContainerStyle: {
            width: "240px",
            margin: "0px",
          },
          editContainerStyle: {
            paddingLeft: "16px",
          },
          applyDefaultStyles: false,
        },
        hasAddRemoveValues: true,
        allowComment: false,
      },
      printType: "BaseComponent",
      mobileType: "TextView",
    },
    hours: {
      // applied this as we want it in all the templates of single page
      // so it should not go inside unitPlanTemplate.json
      skipLocalisation: true,
      config: {
        label: t("unitPlan:unit_hours"),
        isRequiredToCreateUnit: true,
        placeholder: t("common:select"),
        styles: {
          style: {
            width: "100%",
          },
        },
        viewLabel: t("unitPlan:unit_hours"),
        fieldTypeConfig: {
          containerStyle: isMobile
            ? { gap: "4px", flexDirection: "column" }
            : {
                flexDirection: "row",
                alignItems: "center",
                gap: "0px",
              },
          labelContainerStyle: {
            width: "240px",
            margin: "0px",
          },
          editContainerStyle: {
            paddingLeft: "16px",
          },
          applyDefaultStyles: false,
          labelIconContainerStyle: {
            // applied following thing as the labelContainer was applying 16px gap which is given to handle
            // case of giving gap between commentIcon, etc right buttons container and label
            gap: "0px",
          },
          placeholder: t("common:select"),
          timeComponentStyle: {
            height: "40px",
            padding: "2px",
            fontWeight: "600",
            fontSize: "24px",
          },
          borderStyle: {
            border: "none",
          },
          showInputIcon: false,
          showResetButton: true,
          showHoverState: true,
          shouldRegisterLabelContainerRef: true,
        },
        allowComment: false,
        icon: "ClockOutlined",
      },
      type: "DurationFieldInput",
      viewType: "DurationFieldInput",
      mobileType: "TextView",
    },
    unitCode: {
      skipLocalisation: true,
      config: {
        label: t("unitPlan:unit_code"),
        isRequiredToCreateUnit: true,
        placeholder: t("common:select"),
        styles: {
          style: {
            width: "100%",
          },
        },
        viewLabel: t("unitPlan:unit_code"),
        fieldTypeConfig: {
          containerStyle: {
            flexDirection: "row",
            alignItems: "center",
            gap: "0px",
          },
          labelContainerStyle: {
            width: "240px",
            margin: "0px",
          },
          editContainerStyle: {
            paddingLeft: "16px",
          },
          applyDefaultStyles: false,
          placeholder: t("common:select"),
          borderStyle: {
            border: "none",
          },
          showInputIcon: false,
          showHoverState: true,
          shouldRegisterLabelContainerRef: true,
        },
        allowComment: false,
        icon: "SpiralBookLines",
      },
      type: "TextFieldInput",
      viewType: "TextFieldInput",
      mobileType: "TextView",
    },
    relatedConcepts: {
      config: {
        hasAddRemoveValues: true,
        label: isNewPYPConceptsLabelEnabled()
          ? t("common:related_concepts_updated")
          : t("common:related_concepts"),
        subtext: isNewPYPConceptsLabelEnabled()
          ? t("unitPlanTemplate:unitPlan_epypinquiry_relatedConcepts_subtext")
          : t("unitPlanTemplate:unitPlan_relatedConcepts_subtext"),
        plannerElementConfig: {
          type: "PYP_RELATED_CONCEPT",
        },
        type: "PYP_PLANNER_ELEMENT",
        isLearningGoal: true,
        showReflection: false,
      },
      printType: "RelatedConcepts",
      type: "IBRelatedConceptsV2",
      viewType: "IBRelatedConceptsV2",
    },
  };

  _.forEach(fieldConfigMap, (config, key) => {
    if (_.has(fieldList, key)) {
      updateFieldList = {
        ...updateFieldList,
        [key]: { ...fieldList[key], ...config },
      };
    }
  });

  // Subject Configuration based on Curriculum Type
  if (fieldList["subjects"]) {
    let subjectConfig;
    switch (curriculumType) {
      case CURRICULUM_TYPE_MYP:
        subjectConfig = {
          ...(fieldList["subjects"] || {}),
          type: "SubjectGroupSelectV2",
          config: {
            ...(fieldList["subjects"].config || {}),
            type: "SUBJECT",
            label: "",
            styles: {
              listItemStyle: {
                minHeight: 64,
                textAlign: "center",
                alignItems: "center",
                justifyContent: "center",
              },
            },
            fieldTypeConfig: {
              ...(fieldList["subjects"].config.fieldTypeConfig || {}),
              shouldRegisterLabelContainerRef: true,
            },
            emptyText: t("unitPlanTemplate:unitPlan_subjects_emptyText"),
            allowHelpText: false,
          },
          viewType: "SubjectGroupSelectV2",
        };
        break;
      case CURRICULUM_TYPE_DP:
        subjectConfig = {
          ...(fieldList["subjects"] || {}),
          type: "SubjectGroupSubjectViewOnly",
          viewType: "SubjectGroupSubjectViewOnly",
          config: {
            ...(fieldList["subjects"].config || {}),
            type: "SUBJECT",
            label: t("common:subject"),
            emptyText: t("unitPlanTemplate:unitPlan_subjects_emptyText"),
            allowComment: false,
            hasAddRemoveValues: true,
            icon: "OpenBookOutlined",
            fieldTypeConfig: {
              shouldRegisterLabelContainerRef: true,
              containerStyle: isMobile
                ? { gap: "4px", flexDirection: "column" }
                : {
                    gap: "0px",
                    flexDirection: "row",
                    alignItems: "center",
                  },
              labelContainerStyle: {
                width: "240px",
                margin: "0px",
              },
              editContainerStyle: {
                paddingLeft: "16px",
              },
              applyDefaultStyles: false,
            },
            allowHelpText: false,
          },
        };
        break;
      case CURRICULUM_TYPE_PYP:
      case CURRICULUM_TYPE_UBD:
        subjectConfig = {
          ...(fieldList["subjects"] || {}),
          type: "FieldDropdown",
          viewType: "FieldDropdown",
          config: {
            ...(fieldList["subjects"].config || {}),
            icon: "OpenBookOutlined",
            type: "SUBJECT",
            label: t("common:subject_one_or_more"),
            styles: { listItemStyle: { flexBasis: "33%" } },
            viewLabel: t("common:subject_one_or_more"),
            emptyViewText: "",
            subtext: "",
            fieldTypeConfig: {
              ...(fieldList["subjects"].config.fieldTypeConfig || {}),
              multi:
                fieldList["subjects"].config.multi ??
                fieldList["subjects"].config.fieldTypeConfig.multi,
              placeholder: t("common:select"),
              shouldShowArrayValues: true,
              emptyText: t("common:not_selected"),
              textStyle: isMobile
                ? {}
                : {
                    paddingLeft: "16px",
                  },
              shouldRegisterLabelContainerRef: true,
              containerStyle: isMobile
                ? { gap: "4px", flexDirection: "column" }
                : {
                    gap: "0px",
                    flexDirection: "row",
                    alignItems: "center",
                  },
              labelContainerStyle: {
                width: "240px",
                margin: "0px",
              },
              editContainerStyle: {
                paddingLeft: "16px",
              },
              applyDefaultStyles: false,
            },
            hasAddRemoveValues: true,
            allowComment: false,
            allowHelpText: false,
          },
        };
        break;
    }
    subjectConfig = {
      ...subjectConfig,
      skipLocalisation: true,
    };
    if (subjectConfig) {
      updateFieldList = { ...updateFieldList, subjects: subjectConfig };
    }
    return updateFieldList;
  }
};

const getFieldsOrder = ({ curriculumType }) => {
  let list = [];
  switch (curriculumType) {
    case CURRICULUM_TYPE_PYP:
    case CURRICULUM_TYPE_UBD:
      list = [
        "image",
        "title",
        "subtitle",
        "unitCode",
        "subjects",
        "dateDuration",
      ];
      break;
    case CURRICULUM_TYPE_MYP:
      list = ["image", "title", "dateDuration", "hours", "subjects"];
      break;
    case CURRICULUM_TYPE_DP:
      list = [
        "image",
        "title",
        "subjects",
        "dateDuration",
        "hours",
        "subjectLevel",
      ];
      break;
  }

  return list;
};

const updateStepListForCurriculum = ({
  stepList,
  updatedStepList,
  curriculumType,
}) => {
  _.forEach(stepList, (step, stepKey) => {
    let fields = _.get(step, "fields", []);

    if (stepKey === "UNIT_DETAILS") {
      const fieldsOrder = getFieldsOrder({ curriculumType });
      fields = _.sortBy(fields, field => {
        const index = _.indexOf(fieldsOrder, field);
        // If field is not found in fieldsOrder (index is -1),
        // return a large number to push it to the end
        return index === -1 ? Infinity : index;
      });
      updatedStepList[stepKey] = { ...step, fields };
    }
  });
  return updatedStepList;
};

const getStepsWithValidFields = ({
  orderedStepList,
  unitPlanDetails,
  updatedFieldList,
  updatedFieldListV2,
}) => {
  const updatedStepList = {};

  const isLibraryRoute = isToddleLibraryRoute();

  const unitPlanFields = _.get(
    unitPlanDetails,
    "allFields",
    _.get(unitPlanDetails, "fields", [])
  );

  _.forEach(orderedStepList, (step, stepKey) => {
    const fields = _.get(step, "fields", []);
    const validFields = [];

    _.forEach(fields, field => {
      const isFieldValueNotNull = checkEmptyElementValue({
        fieldKey: field,
        data: unitPlanDetails,
        fieldObj: _.get(updatedFieldList, field, {}),
        unitPlanFields,
        getElementValue,
      });

      const isFieldLocked =
        _.get(updatedFieldListV2, [
          field,
          "lockFieldForSchoolGroups",
          "value",
        ]) ??
        _.get(
          updatedFieldList,
          [field, "config", "lockFieldForSchoolGroups"],
          false
        );

      // Add to validFields if the field has a non-null value,
      // or if it is unlocked AND we are not on a Toddle Library route
      // (on the library route, fields with null values are excluded regardless of lock status)
      if (isFieldValueNotNull || (!isFieldLocked && !isLibraryRoute)) {
        validFields.push(field);
      }
    });

    if (validFields.length > 0)
      updatedStepList[stepKey] = {
        ...step,
        fields: validFields,
      };
  });

  return updatedStepList;
};

const removeStagesWithNoSteps = ({ updatedStageList, updatedStepList }) => {
  _.forEach(updatedStageList, (stage, stageKey) => {
    const filteredSteps = _.filter(_.get(stage, "steps", []), stepKey =>
      _.has(updatedStepList, stepKey)
    );

    if (!_.isEmpty(filteredSteps)) {
      updatedStageList[stageKey] = {
        ...stage,
        steps: filteredSteps,
      };
    } else {
      // Remove the stage if it has no visible steps
      delete updatedStageList[stageKey];
    }
  });

  return updatedStageList;
};

const updateKeyAndRelatedConcepts = ({ template }) => {
  const { body = {} } = template;
  const { field_list = {}, step_list = {} } = body;
  //fieldList and step list is a object with key and valu and inside value there is config and inside config there is label and subtext and i want to update the label and subtext by replacing the word related with additional and it should only be updated if there is a word related inside it if its 1st letter it should be Additional and if its in middle of sentence it should be additional

  const updatedFieldList = _.mapValues(field_list, (field, key) => {
    const { config = {} } = field;
    const { label = "", subtext = "", type } = config;
    if (type === "PYP_PLANNER_ELEMENT") {
      let updatedLabel = label.replace(/related/g, "other");
      updatedLabel = updatedLabel.replace(/Related/g, "Other");
      updatedLabel = updatedLabel.replace(/Key/g, "Specified");
      updatedLabel = updatedLabel.replace(/key/g, "specified");
      //spanish
      updatedLabel = updatedLabel.replace(/relacionados/g, "adicional");
      updatedLabel = updatedLabel.replace(/clave/g, "especificados");

      //french
      updatedLabel = updatedLabel.replace(/connexes/g, "supplémentaire");
      updatedLabel = updatedLabel.replace(/clés/g, "spécifiés");

      //chineese
      updatedLabel = updatedLabel.replace(/相关/g, "额外的");
      updatedLabel = updatedLabel.replace(/重要/g, "指定的");

      //portugese
      updatedLabel = updatedLabel.replace(/relacionados/g, "adicional");
      updatedLabel = updatedLabel.replace(/chave/g, "especificados");

      //turkish
      updatedLabel = updatedLabel.replace(/Bağlantılı/g, "Ek olarak");
      updatedLabel = updatedLabel.replace(/bağlantılı/g, "ek olarak");
      updatedLabel = updatedLabel.replace(/Anahtar/g, "Belirtilen");
      updatedLabel = updatedLabel.replace(/anahtar/g, "belirtilen");

      let updatedSubtext = subtext.replace(/related/g, "other");
      updatedSubtext = updatedSubtext.replace(/Related/g, "Other");
      updatedSubtext = updatedSubtext.replace(/Key/g, "Specified");
      updatedSubtext = updatedSubtext.replace(/key/g, "specified");

      //spanish
      updatedSubtext = updatedSubtext.replace(/relacionados/g, "adicional");
      updatedSubtext = updatedSubtext.replace(/clave/g, "especificados");

      //french
      updatedSubtext = updatedSubtext.replace(/connexes/g, "supplémentaire");
      updatedSubtext = updatedSubtext.replace(/clés/g, "spécifiés");

      //chineese
      updatedSubtext = updatedSubtext.replace(/相关/g, "额外的");
      updatedSubtext = updatedSubtext.replace(/重要/g, "指定的");

      //portugese
      updatedSubtext = updatedSubtext.replace(/relacionados/g, "adicional");
      updatedSubtext = updatedSubtext.replace(/chave/g, "especificados");

      //turkish
      updatedSubtext = updatedSubtext.replace(/Bağlantılı/g, "Ek olarak");
      updatedSubtext = updatedSubtext.replace(/bağlantılı/g, "ek olarak");
      updatedSubtext = updatedSubtext.replace(/Anahtar/g, "Belirtilen");
      updatedSubtext = updatedSubtext.replace(/anahtar/g, "belirtilen");

      return {
        ...field,
        config: {
          ...config,
          ...(updatedLabel ? { label: updatedLabel } : {}),
          ...(updatedSubtext ? { subtext: updatedSubtext } : {}),
        },
      };
    } else {
      return field;
    }
  });

  const updatedStepList = _.mapValues(step_list, (step, key) => {
    const { label = "", subtext = "", fields = [] } = step;
    const doesSomeFieldHasTypePlannerElement = _.some(fields, field => {
      const fieldObj = field_list[field];
      return fieldObj?.config?.type === "PYP_PLANNER_ELEMENT";
    });
    if (doesSomeFieldHasTypePlannerElement) {
      let updatedLabel = label.replace(/related/g, "other");
      updatedLabel = updatedLabel.replace(/Related/g, "Other");
      updatedLabel = updatedLabel.replace(/Key/g, "Specified");
      updatedLabel = updatedLabel.replace(/key/g, "specified");

      //spanish
      updatedLabel = updatedLabel.replace(/relacionados/g, "adicional");
      updatedLabel = updatedLabel.replace(/clave/g, "especificados");

      //french
      updatedLabel = updatedLabel.replace(/connexes/g, "supplémentaire");
      updatedLabel = updatedLabel.replace(/clés/g, "spécifiés");

      //chineese
      updatedLabel = updatedLabel.replace(/相关/g, "额外的");
      updatedLabel = updatedLabel.replace(/重要/g, "指定的");

      //portugese
      updatedLabel = updatedLabel.replace(/relacionados/g, "adicional");
      updatedLabel = updatedLabel.replace(/chave/g, "especificados");

      //turkish
      updatedLabel = updatedLabel.replace(/Bağlantılı/g, "Ek olarak");
      updatedLabel = updatedLabel.replace(/bağlantılı/g, "ek olarak");
      updatedLabel = updatedLabel.replace(/Anahtar/g, "Belirtilen");
      updatedLabel = updatedLabel.replace(/anahtar/g, "belirtilen");

      let updatedSubtext = subtext.replace(/related/g, "other");
      updatedSubtext = updatedSubtext.replace(/Related/g, "Other");
      updatedSubtext = updatedSubtext.replace(/Key/g, "Specified");
      updatedSubtext = updatedSubtext.replace(/key/g, "specified");

      //spanish
      updatedSubtext = updatedSubtext.replace(/relacionados/g, "adicional");
      updatedSubtext = updatedSubtext.replace(/clave/g, "especificados");

      //french
      updatedSubtext = updatedSubtext.replace(/connexes/g, "supplémentaire");
      updatedSubtext = updatedSubtext.replace(/clés/g, "spécifiés");

      //chineese
      updatedSubtext = updatedSubtext.replace(/相关/g, "额外的");
      updatedSubtext = updatedSubtext.replace(/重要/g, "指定的");

      //portugese
      updatedSubtext = updatedSubtext.replace(/relacionados/g, "adicional");
      updatedSubtext = updatedSubtext.replace(/chave/g, "especificados");

      //turkish
      updatedSubtext = updatedSubtext.replace(/Bağlantılı/g, "Ek olarak");
      updatedSubtext = updatedSubtext.replace(/bağlantılı/g, "ek olarak");
      updatedSubtext = updatedSubtext.replace(/Anahtar/g, "Belirtilen");
      updatedSubtext = updatedSubtext.replace(/anahtar/g, "belirtilen");
      return {
        ...step,
        ...(updatedLabel ? { label: updatedLabel } : {}),
        ...(updatedSubtext ? { subtext: updatedSubtext } : {}),
      };
    } else {
      return step;
    }
  });

  return {
    ...template,
    body: {
      ...body,
      field_list: updatedFieldList,
      step_list: updatedStepList,
    },
  };
};

//#hack for freemium
export const updateTemplate = ({
  t,
  tool,
  template,
  unitType,
  userType,
  unitPlanDetails,
  curriculumType = "IB_PYP",
  resolvedSubjectNodes = [],
  userLevelType,
  isImported,
  fieldListV2 = {},
  plannerElementSets,
  isSinglePageAndNewUnitView,
  shouldUpdateViewTypeInSinglePage,
  isLearningCoursesEnabled,
  isCourseBasedGradingEnabled,
  isLibraryMypGrade = false,
  enableAllFields,
  isConvertPortedToNonPortedFieldsEnabled = true,
  skipTemplateUpdateForToddleLibrary,
}) => {
  if (
    ACLStore.can("FeatureFlag:NewPYPConceptsLabelEnabled") &&
    _.isEqual(curriculumType, CURRICULUM_TYPE_PYP)
  ) {
    template = updateKeyAndRelatedConcepts({
      template: _.cloneDeep(template),
    });
  }

  const templateBody = _.get(template, "body", {});
  const isBilingual = _.get(template, "isBilingual", false);
  const isGlobal = _.get(template, "isGlobal", false);
  const courseOverview = _.get(templateBody, "courseOverview", []);
  const stepList = _.get(templateBody, "step_list", {});
  const stageList = _.get(templateBody, "stage_list", {});
  const webElementPYP = _.get(templateBody, "webElementPYP", []);
  const moduleList = _.get(templateBody, "module_list", {});
  const fieldList = _.get(templateBody, "field_list", {});
  const modules = _.get(templateBody, "modules", []);
  const lockFieldsList = _.get(templateBody, `lock_fields`, []);
  const rightPane = _.get(templateBody, "rightPane", []);
  const learningCourse = _.get(unitPlanDetails, "learningCourse", {});
  const isBlueprintCourse = getIsBlueprintCourse(learningCourse);

  let updatedStepList = { ...stepList };
  let updateFieldList = _.cloneDeep(fieldList);
  let updatedFieldListV2 = { ...fieldListV2 };
  let updatedStageList = { ...stageList };
  let updatedWebElementPYP = [...webElementPYP];
  let updatedModuleList = { ...moduleList };
  let updatedModules = [...modules];
  let updatedRightPane = [...rightPane];

  const displayNewFieldsInOldView = isDisplayNewFieldsInOldViewEnabled();

  if (
    (isSinglePageAndNewUnitView || displayNewFieldsInOldView) &&
    !skipTemplateUpdateForToddleLibrary
  ) {
    updateFieldList = updateFieldConfigurations({
      fieldList,
      updateFieldList,
      curriculumType,
      t,
    });
  }

  if (isLearningCoursesEnabled) {
    updateFieldList = updateFieldListForLearningCourse({
      updateFieldList,
      t,
      isCourseBasedGradingEnabled,
      isGlobal,
    });
    if (isGlobal)
      updatedStepList = updateStepListForLearningCourse({
        updatedStepList,
        t,
        isGlobal,
      });
  }

  const updatedCourseOverview = [...courseOverview];

  const isLocalisedTemplate = _.get(
    template,
    "body.isLocalisedTemplate",
    false
  );
  if (curriculumType == CURRICULUM_TYPE_PYP) {
    updatedStepList = {};
    _.forEach(stepList, (step, stepKey) => {
      let fields = [];
      _.forEach(_.get(step, "fields", []), field => {
        let fieldName = field;
        if (
          field == "fmtAssessments" ||
          field == "smtAssessments" ||
          field == "digAssessments"
        ) {
          fieldName = "les";
        }
        fields.push(fieldName);
      });
      fields = _.filter(fields, field => !_.isEqual("studentAction", field));
      // Add support for rubric in unit plan template for PYP
      if (stepKey == "ASSESSMENTTOOL") {
        if (tool) {
          fields = [
            ...fields,
            _.get(_.find(ASSESSMENT_TOOLS, { type: tool }), "key", ""),
          ];
        }
      }
      updatedStepList[stepKey] = { ...step, fields };
    });
    if (fieldList["les"]) {
      updateFieldList = {
        ...updateFieldList,
        les: { ...fieldList["les"], type: "IBAssessments" },
      };
    }
    if (fieldList["studentAction"]) {
      updateFieldList = {
        ...updateFieldList,
        studentAction: {
          ...(fieldList["studentAction"] || {}),
          type: "",
          viewType: "",
          config: {
            ...(_.get(fieldList["studentAction"], "config", {}) || {}),
            showReflection: false,
          },
        },
      };
    }

    updatedWebElementPYP = _.filter(
      webElementPYP,
      element => element.value != "assessment"
    );
  }
  //For a  MYP Interdisciplinary Planner dynamically addings steps/fields for each subject

  // Move this function to print
  else if (unitType == "ibMYPInterdisciplinary" && !_.isEmpty(templateBody)) {
    const disciplinaryStage = stageList["S_DISCIPLINARY"];
    const disciplinarySteps = disciplinaryStage.steps;
    const disciplinaryStep = stepList["DISCIPLINARY"];
    const unitDetailsModule = moduleList["unitDetails"];

    const subjectDisciplinarySteps = _.map(resolvedSubjectNodes, subject => {
      let disciplinaryStepLabel;
      if (isBilingual) {
        disciplinaryStepLabel =
          `${subject.name} - ` +
          getBilingualText({
            text: "Disciplinary grounding",
            bilingualText: _.get(
              stepList["DISCIPLINARY"],
              "bilingualConfig.label",
              ""
            ),
          });
      } else {
        disciplinaryStepLabel = ACLStore.can(
          ENABLE_DYNAMIC_LOCALISATION_OF_TEMPLATE
        )
          ? _.join(
              [subject.name, _.get(stepList["DISCIPLINARY"], "label", "")],
              " - "
            )
          : t(
              `unitPlanTemplate:${extractLabelsForTranslation({
                keys: [
                  "unitPlan",
                  "MYPInterdisciplinary",
                  "DISCIPLINARY",
                  "label",
                ],
              })}`,
              {
                label: subject.name,
              }
            );
      }

      const stepKey = `DISCIPLINARY_${subject.id}`;
      const subjectDisciplinaryStep = {
        ...disciplinaryStep,
        label: disciplinaryStepLabel,
        localisedLabel: disciplinaryStepLabel,
        skipLocalisation: true,
        isArchived: _.get(subject, "isArchived", false),
        subjectName: subject.name,
      };

      subjectDisciplinaryStep["fields"] = _.map(
        disciplinaryStep.fields,
        key => {
          if (
            enableAllFields &&
            !_.find(updatedCourseOverview, { fieldUID: key })
          ) {
            updatedCourseOverview.push({ fieldUID: key });
          }
          const fieldKey = `${key}_${subject.id}`;
          const plannerElementConfig = _.get(
            fieldList[key],
            "config.plannerElementConfig",
            {}
          );
          const { type } = plannerElementConfig;

          let { label } = getCurrentPlannerElementSetFromState(type)(
            store.getState()
          );

          if (_.isEmpty(label)) {
            label = t(
              `unitPlanTemplate:${extractLabelsForTranslation({
                keys: [
                  "unitPlan",
                  "MYPInterdisciplinary",
                  key,
                  "label",
                  "with",
                  "subject",
                ],
              })}`,
              {
                subject: subject.name,
              }
            );
          } else {
            label = `${label} - ${subject.name}`;
          }

          updateFieldList[fieldKey] = {
            ...fieldList[key],
            config: {
              ...(fieldList[key].config || {}),
              label:
                ACLStore.can(ENABLE_DYNAMIC_LOCALISATION_OF_TEMPLATE) ||
                !isLocalisedTemplate
                  ? _.get(fieldList[key], "config.label", "") +
                    ` - ${subject.name}`
                  : label,
              subtext:
                ACLStore.can(ENABLE_DYNAMIC_LOCALISATION_OF_TEMPLATE) ||
                !isLocalisedTemplate
                  ? _.get(fieldList[key], "config.subtext", "")
                  : t(
                      `unitPlanTemplate:${extractLabelsForTranslation({
                        keys: [
                          "unitPlan",
                          "MYPInterdisciplinary",
                          key,
                          "subtext",
                        ],
                      })}`,
                      {
                        subject: subject.name,
                      }
                    ),
            },
            skipLocalisation: true,
            staticKey: key,
            dynamicSubject: subject,
          };
          return fieldKey;
        }
      );
      updatedStepList[stepKey] = subjectDisciplinaryStep;

      return stepKey;
    });

    const disciplinaryStepEditIndex = _.indexOf(
      disciplinarySteps,
      "DISCIPLINARY"
    );

    const disciplinaryStepIndex = _.indexOf(
      unitDetailsModule.viewSteps,
      "DISCIPLINARY"
    );

    updatedStageList["S_DISCIPLINARY"] = {
      ...disciplinaryStage,
      steps: update(disciplinarySteps, {
        $splice: [[disciplinaryStepEditIndex, 1, ...subjectDisciplinarySteps]],
      }),
    };

    updatedModuleList = update(updatedModuleList, {
      unitDetails: {
        viewSteps: {
          $splice: [[disciplinaryStepIndex, 1, ...subjectDisciplinarySteps]],
        },
      },
    });
  }

  //Allow image cropping when permission is true
  if (
    ACLStore.can("FeatureFlag:EnableImageCroppingUnitPlan") &&
    _.has(updateFieldList, "image.config")
  ) {
    updateFieldList.image.config.fieldTypeConfig = {
      showCroppingModal: true,
    };
  }

  // Handles the unit sharing for non-staff user
  if (_.includes(["student", "parent"], userType)) {
    let sharedSteps = [];
    const tempModules = [];

    const enabledSectionsForAUser = _.find(
      _.get(unitPlanDetails, "enabledSections", []),
      { userType: "student_parent" } //we need to pass student_parent as we need to share same sections for both users
    );

    sharedSteps = _.get(enabledSectionsForAUser, "sections", []);

    _.forEach(updatedModuleList, (module, key) => {
      const allowedModuleSteps = _.filter(
        _.get(module, "viewSteps", []),
        stepId => {
          const step = updatedStepList[stepId];
          const shareConfig = _.get(step, "shareConfig", {});

          if (_.has(shareConfig, "canShareWithUser")) {
            return shareConfig["canShareWithUser"];
          }

          return true;
        }
      );

      if (!_.isEmpty(_.intersection(allowedModuleSteps, sharedSteps))) {
        tempModules.push(key);
        updatedModuleList[key] = {
          ...updatedModuleList[key],
          viewSteps: _.intersection(allowedModuleSteps, sharedSteps),
        };
      }

      const viewStepList = _.get(updatedModuleList, `${key}.viewSteps`, []);
      const viewStepCount = viewStepList.length;
      //update card style for student and parent view
      _.forEach(viewStepList, (viewStep, index) => {
        //give the number of cards to be displayed in one row when sharing the unit
        //we are passing it this way as teacher can change the steps to be displayed to students or parents so the style may give empty space
        const cardsPerRow = 3;
        let width = 100 / cardsPerRow;
        const lastRowCardCount = viewStepList.length % cardsPerRow;
        if (lastRowCardCount > 0 && viewStepCount - index <= lastRowCardCount)
          width = 100 / lastRowCardCount;

        updatedStepList[viewStep] = {
          ...updatedStepList[viewStep],
          styles: {
            viewStyle: {
              width: width + "%",
            },
          },
        };
      });

      //uncomment the below code if we need to display unit flow in student and parent sharing
      // Handled the case specifically for unit flow
      if (_.isEqual(key, "unitFlow") && isLearningCoursesEnabled) {
        tempModules.push(key);
      }
    });
    if (isSinglePageAndNewUnitView) {
      const filteredStepList = {};
      const requiredStepKeys = [...sharedSteps, "UNIT_DETAILS"];
      _.forEach(requiredStepKeys, stepKey => {
        const step = updatedStepList[stepKey];
        const shareConfig = _.get(step, "shareConfig", {});
        if (
          step &&
          (!_.has(shareConfig, "canShareWithUser") ||
            shareConfig.canShareWithUser === true)
        ) {
          filteredStepList[stepKey] = step;
        }
      });
      // Update step list to only include steps that can be shared
      updatedStepList = filteredStepList;

      // Also update stage_list to only include stages with available steps
      _.forEach(updatedStageList, (stage, stageKey) => {
        const filteredSteps = _.filter(_.get(stage, "steps", []), stepKey =>
          _.has(updatedStepList, stepKey)
        );

        if (!_.isEmpty(filteredSteps)) {
          updatedStageList[stageKey] = {
            ...stage,
            steps: filteredSteps,
          };
        } else {
          // Remove the stage if it has no visible steps
          delete updatedStageList[stageKey];
        }
      });
    }
    // Using intersection to follow the template order of modules
    updatedModules = _.intersection(updatedModules, tempModules);
  }

  if (curriculumType == CURRICULUM_TYPE_UBD) {
    // Add support for rubric in unit plan template for UBD
    _.forEach(stepList, (step, stepKey) => {
      let fields = step.fields;

      if (stepKey == "ASSESSMENTTOOL") {
        if (tool) {
          fields = [
            ...fields,
            _.get(_.find(ASSESSMENT_TOOLS, { type: tool }), "key", ""),
          ];
        }

        updatedStepList[stepKey] = { ...step, fields };
      }
    });
  }

  if (isSinglePageAndNewUnitView) {
    updatedModuleList = updatedModuleListForStage({
      updatedModuleList,
      updatedModules,
    });
  }
  //this will append isLock true
  //if unit is imported from maple bear lib than only lock fields
  /**
   * current locking mechanism condition is only applicable to maple bear
   * here cant apply general condition because of their own different config. on platform
   * one can create general condition and apply in OR in IF condition.
   */
  const mapleBearSpecCondition =
    mapleBearLikeOrg() && userLevelType === "educator" && isImported;

  if (mapleBearSpecCondition) {
    lockFields({
      step_list: stepList,
      lockField: lockFieldsList,
      updatedStepField: updatedStepList,
      updatedFieldList: updateFieldList,
      updatedFieldListV2,
    });
  }

  const insightElementPYP = _.get(template, "body.insightElementPYP", []);
  if (isBilingual) {
    updateFieldList = updateFieldListForBilingual({
      fieldList: updateFieldList,
    });
    updatedFieldListV2 = updateFieldListV2ForBilingual({
      fieldList: fieldListV2,
    });
    updatedStepList = updateOtherListForBilingual({
      list: updatedStepList,
    });
    updatedStageList = updateOtherListForBilingual({
      list: updatedStageList,
    });
    updatedModuleList = updateOtherListForBilingual({
      list: updatedModuleList,
    });
    // get bilingual field labels for insight elements
    update(insightElementPYP, {
      $apply: array =>
        array.map(field => ({
          ...field,
          label: _.get(updateFieldList[field.value], "config.label", ""),
        })),
    });
  }

  /**
   * The MultiWindowTable field is not ported, but some of its subFields have filteredBy field references that are ported.
   * To manage this scenario without introducing fieldListV2 in the non-ported field flow, we are adding a boolean isFilteredByFieldPorted
   *  to determine whether the filteredBy field is ported or not.
   */

  updateFieldList = _updateFieldListForMultiWindowTable({
    fieldList: updateFieldList,
    fieldListV2: updatedFieldListV2,
  });

  if (
    curriculumType == CURRICULUM_TYPE_PYP &&
    ACLStore.can(ENABLE_ASSESSMENTS_IN_PYP)
  ) {
    if (!_.includes(updatedRightPane, ASSESSMENT_LIBRARY)) {
      const leLibraryIndex = _.indexOf(updatedRightPane, "LE_LIBRARY");

      // place assessment library tab after LE library tab
      // because the order is like that in most templates
      if (leLibraryIndex !== -1) {
        updatedRightPane.splice(leLibraryIndex + 1, 0, ASSESSMENT_LIBRARY);
      } else {
        updatedRightPane = [...updatedRightPane, ASSESSMENT_LIBRARY];
      }
    }
  }

  if (isLibraryMypGrade && !_.includes(updatedRightPane, "WORKSHEET")) {
    updatedRightPane = [...updatedRightPane, "WORKSHEET"];
  }

  // ** Currently AI in old unit plan view is disabled
  // ** will enable or remove the code later
  // const isUnitPlanAIEnabled = ACLStore.can(UNIT_PLAN_AI_PERMISSION);
  const isUnitPlanAIEnabled = false;
  if (isUnitPlanAIEnabled) {
    updatedRightPane = [...updatedRightPane, "UNIT_PLAN_AI_ASSISTANT"];
  }

  updateFieldList = getUpdatedSinglePageUnitPlanFields({
    fieldList: updateFieldList,
    shouldUpdateViewTypeInSinglePage,
    t,
    isLearningCoursesEnabled,
    isCourseBasedGradingEnabled,
    stepList: updatedStepList,
    isMYPInterdisciplinary: unitType === "ibMYPInterdisciplinary",
    skipTemplateUpdateForToddleLibrary,
  });

  updatedFieldListV2 = updateFieldListV2ForSinglePage(
    updatedFieldListV2,
    skipTemplateUpdateForToddleLibrary
  );

  if (curriculumType === CURRICULUM_TYPE_PYP) {
    updatedStepList = getUpdatedSinglePageUnitPlanStepList({
      stepList: updatedStepList,
      skipTemplateUpdateForToddleLibrary,
    });
  }

  if (
    (isSinglePageAndNewUnitView || displayNewFieldsInOldView) &&
    !skipTemplateUpdateForToddleLibrary
  ) {
    updatedStepList = updateStepListForCurriculum({
      stepList,
      curriculumType,
      updatedStepList,
    });

    if (mapleBearSpecCondition || isToddleLibraryRoute()) {
      updatedStepList = getStepsWithValidFields({
        orderedStepList: updatedStepList,
        unitPlanDetails,
        updatedFieldList: updateFieldList,
        updatedFieldListV2,
      });

      updatedStageList = removeStagesWithNoSteps({
        updatedStageList,
        updatedStepList,
      });
    }
  }

  if (isLearningCoursesEnabled && curriculumType !== CURRICULUM_TYPE_DP) {
    if (!_.has(updateFieldList, "subjectLevel")) {
      updateFieldList = {
        ...updateFieldList,
        subjectLevel: {
          id: "subjectLevel",
          type: "MultiSelect",
          config: {
            label: t("unitPlan:levels_with_parenthesis"),
            subText: "",
            isRequired: false,
            showReflection: false,
            fieldTypeConfig: {
              multi: true,
              tickPosition: "top",
              useListStyle: "grid",
              showSubtextUnderInfo: true,
              isMultiSelectComponentV2: true,
            },
            showInUnitSummary: false,
            hasAddRemoveValues: true,
            isRequiredToCreateUnit: true,
          },
          viewType: "TextView",
          printType: "BaseComponent",
        },
      };
    }
    const unitDetailsFields = _.get(updatedStepList, "UNIT_DETAILS.fields", []);
    if (!_.includes(unitDetailsFields, "subjectLevel")) {
      updatedStepList = {
        ...updatedStepList,
        UNIT_DETAILS: {
          ...updatedStepList["UNIT_DETAILS"],
          fields: [...unitDetailsFields, "subjectLevel"],
          draft_fields: [
            ..._.get(updatedStepList, "UNIT_DETAILS.draft_fields", []),
            "subjectLevel",
          ],
        },
      };
    }
  }

  if (isBlueprintCourse) {
    updatedModules = _.filter(updatedModules, moduleKey => {
      return moduleKey !== "evidence" && moduleKey !== "reflection";
    });
  }

  if (curriculumType === CURRICULUM_TYPE_PYP) {
    const hasConceptsQuestion = _.has(updateFieldList, "conceptsQuestion");
    if (hasConceptsQuestion) {
      const conceptsQuestionField = {
        fieldUID: "conceptsQuestion",
      };
      updatedCourseOverview.push(conceptsQuestionField);
    }
    if (enableAllFields) {
      const hasActionsQuestion = _.has(updateFieldList, "actionQuestion");
      if (hasActionsQuestion) {
        const actionsQuestionField = {
          fieldUID: "actionQuestion",
        };
        updatedCourseOverview.push(actionsQuestionField);
      }
    }
  }
  const localisedTemplate = getLocalisedTemplate({
    template: {
      ...template,
      body: {
        ...templateBody,
        modules: updatedModules,
        viewModules: updatedModules,
        module_list: updatedModuleList,
        stage_list: updatedStageList,
        step_list: updatedStepList,
        webElementPYP: updatedWebElementPYP,
        field_list: updateFieldList,
        fieldListV2: updatedFieldListV2,
        insightElementPYP,
        rightPane: updatedRightPane,
        courseOverview: updatedCourseOverview,
      },
    },
    t,
    templateType: "unitPlan",
  });
  if (
    isConvertPortedToNonPortedFieldsEnabled &&
    shouldConvertNonPortedFieldsToPorted() &&
    !skipTemplateUpdateForToddleLibrary
  ) {
    const convertedFields = convertNonPortedToPorted({
      template: localisedTemplate,
      templateId: template.id,
      plannerElementSets,
    });

    return {
      ...localisedTemplate,
      body: {
        ...localisedTemplate.body,
        fieldListV2: {
          ...convertedFields,
          ...updatedFieldListV2,
        },
      },
    };
  }
  return localisedTemplate;
};

export const updateTemplateMemoize = _.memoize(
  ({
    t,
    tool,
    template,
    unitType,
    userType,
    courseId,
    curriculumType,
    unitPlanDetails,
    isLibraryMypGrade,
    resolvedSubjectNodes,
    userLevelType,
    isImported,
    plannerElementSets,
    isSinglePageAndNewUnitView,
    isLearningCoursesEnabled,
    isCourseBasedGradingEnabled,
    isConvertPortedToNonPortedFieldsEnabled,
    language /* DO NOT REMOVE THIS
    it is not used anywhere but added as a hack because in case when we are changing the language update template
    is not called so to call update template and localise the template with specific language it is added*/,
    fieldListV2,
    skipTemplateUpdateForToddleLibrary,
  }) =>
    updateTemplate({
      t,
      tool,
      template,
      unitType,
      userType,
      courseId,
      curriculumType,
      unitPlanDetails,
      resolvedSubjectNodes,
      userLevelType,
      isImported,
      language,
      fieldListV2,
      plannerElementSets,
      isSinglePageAndNewUnitView,
      isLearningCoursesEnabled,
      isCourseBasedGradingEnabled,
      isLibraryMypGrade,
      isConvertPortedToNonPortedFieldsEnabled,
      skipTemplateUpdateForToddleLibrary,
    }),
  // *HACK: unitPlanDetails prevents memoization for some reason, so we only include enabledSections
  params =>
    JSON.stringify({
      ..._.omit(params, ["unitPlanDetails"]),
      isLibraryMypGrade: _.get(params, "isLibraryMypGrade", null),
      enabledSections: _.get(params.unitPlanDetails, "enabledSections", []),
      learningCourse: _.get(params.unitPlanDetails, "learningCourse", {}),
    })
);

export const getHelpTextLabel = ({ uid, template }) => {
  const {
    helpEnabledFields,
    body: { step_list = {}, field_list = {} },
  } = template;
  const type = _.get(_.find(helpEnabledFields, { uid }), "type", "FIELD");

  switch (type) {
    case "FIELD": {
      const { config: { label = "", viewLabel = "" } = {} } =
        field_list[uid] ?? {};

      return viewLabel ? viewLabel : label;
    }
    case "STEP": {
      const label = _.get(step_list, `${uid}.label`, "");
      return label;
    }
    default:
      return "";
  }
};

export const getLocalisedTemplate = ({ template, t, templateType }) => {
  const isLocalisedTemplate = _.get(
    template,
    "body.isLocalisedTemplate",
    false
  );
  const body = _.get(template, "body", {});
  const localisedTemplateId = _.get(template, "body.localisedTemplateId", "");
  const localisationKeys = [
    "label",
    "viewLabel",
    "subLabel",
    "labelForStudent",
    "labelForParent",
    "subtext",
    "prompts",
    "promptsLabel",
    "placeholder",
    "emptyText",
    "emptyEditText",
    "blockSubText",
    "error",
    "startDateLabel",
    "endDateLabel",
  ];
  const localisationLists = [
    "field_list",
    "module_list",
    "stage_list",
    "step_list",
    "fieldListV2",
  ];
  if (
    isLocalisedTemplate &&
    !(
      ACLStore.can(ENABLE_DYNAMIC_LOCALISATION_OF_TEMPLATE) &&
      templateType === "unitPlan"
    )
  ) {
    _.forEach(body, (list, key) => {
      if (_.includes(localisationLists, key)) {
        _.forEach(list, (item, itemKey) => {
          switch (key) {
            case "field_list": {
              if (!item.skipLocalisation) {
                body[key][itemKey] = {
                  ...body[key][itemKey],
                  config: getLocalisedConfig({
                    config: _.get(item, "config", {}),
                    t,
                    templateType,
                    localisedTemplateId,
                    itemKey,
                    localisationKeys,
                  }),
                };
                if (_.has(item, "subFields")) {
                  body[key][itemKey] = {
                    ...body[key][itemKey],
                    subFields: getLocalisedSubFields({
                      subFields: _.get(item, "subFields", {}),
                      t,
                      templateType,
                      localisedTemplateId,
                      itemKey,
                      localisationKeys,
                    }),
                  };
                }
              }
              break;
            }
            case "fieldListV2": {
              body[key][itemKey] = _getLocalisedConfigV2({
                config: item,
                t,
                templateType,
                localisedTemplateId,
                itemKey,
                localisationKeys,
              });
              break;
            }

            default: {
              body[key][itemKey] = getLocalisedItem({
                item,
                t,
                templateType,
                localisedTemplateId,
                itemKey,
                localisationKeys,
              });
            }
          }
        });
      }
    });
  }

  return template;
};

export const getLocalisedSubFields = ({
  subFields,
  t,
  templateType,
  localisedTemplateId,
  localisationKeys,
}) => {
  return _.map(subFields, subField => {
    return {
      ...subField,
      config: getLocalisedConfig({
        config: _.get(subField, "config", {}),
        t,
        templateType,
        localisedTemplateId,
        itemKey: _.get(subField, "key", {}),
        localisationKeys,
      }),
    };
  });
};

export const getLocalisedConfig = ({
  config,
  t,
  templateType,
  localisedTemplateId,
  itemKey,
  localisationKeys,
  configType = "",
}) => {
  let fieldConfig = { ...config };
  _.forEach(config, (value, configKey) => {
    if (_.includes(localisationKeys, configKey)) {
      fieldConfig = {
        ...fieldConfig,
        [configKey]:
          value &&
          t(
            `unitPlanTemplate:${extractLabelsForTranslation({
              keys: [
                templateType,
                localisedTemplateId,
                itemKey,
                configType,
                configKey,
              ],
            })}`
          ),
      };
    }
    if (configKey == "fieldTypeConfig") {
      fieldConfig = {
        ...fieldConfig,
        fieldTypeConfig: getLocalisedConfig({
          config: _.get(config, "fieldTypeConfig", {}),
          t,
          templateType,
          localisedTemplateId,
          itemKey,
          localisationKeys,
          configType: "fieldTypeConfig",
        }),
      };
    }
    if (configKey === "promptsConfig") {
      fieldConfig = {
        ...fieldConfig,
        promptsConfig: getLocalisedConfig({
          config: _.get(config, "promptsConfig", {}),
          t,
          templateType,
          localisedTemplateId,
          itemKey,
          localisationKeys,
          configType: "promptsConfig",
        }),
      };
    }
  });
  return fieldConfig;
};

const _getLocalisedConfigV2 = ({
  config,
  t,
  templateType,
  localisedTemplateId,
  itemKey,
  localisationKeys,
}) => {
  const propertyKeys = _.keys(config);
  return _.reduce(
    propertyKeys,
    (result, propertyKey) => {
      const propertyValueObj = config[propertyKey];
      const propertyValue = propertyValueObj.value;

      if (
        !_.includes(localisationKeys, propertyKey) ||
        _.isEmpty(propertyValue)
      ) {
        return { ...result, [propertyKey]: propertyValueObj };
      }

      let configKey = propertyKey;
      let configType = "";

      //TODO: generate new locale keys for prompts
      if (propertyKey === "promptsLabel") {
        configType = "promptsConfig";
        configKey = "label";
      }

      const localisedValue = t(
        `unitPlanTemplate:${extractLabelsForTranslation({
          keys: [
            templateType,
            localisedTemplateId,
            itemKey,
            configType,
            configKey,
          ],
        })}`
      );

      return {
        ...result,
        [propertyKey]: {
          ...propertyValueObj,
          value: localisedValue,
        },
      };
    },
    {}
  );
};

export const getLocalisedItem = ({
  item,
  t,
  templateType,
  localisedTemplateId,
  itemKey,
  localisationKeys,
  configType = "",
}) => {
  let step = { ...item };
  _.forEach(item, (field, fieldKey) => {
    if (!item.skipLocalisation && _.includes(localisationKeys, fieldKey)) {
      step = {
        ...step,
        [fieldKey]:
          field &&
          t(
            `unitPlanTemplate:${extractLabelsForTranslation({
              keys: [
                templateType,
                localisedTemplateId,
                itemKey,
                configType,
                fieldKey,
              ],
            })}`
          ),
      };
    }
    if (fieldKey === "pageHeaderConfig") {
      step = {
        ...step,
        pageHeaderConfig: getLocalisedItem({
          item: _.get(step, "pageHeaderConfig", {}),
          t,
          templateType,
          localisedTemplateId,
          itemKey,
          localisationKeys,
          configType: "pageHeaderConfig",
        }),
      };
    }
  });
  return step;
};

export const reRouteToStep = step => {
  return (dispatch, getState) => {
    const path = getRelativePath(step);
    replace(path);
  };
};

export const changeCurrentStepRoute = ({ step, queryParams }) => {
  return (dispatch, getState) => {
    const path = getRelativePath(`../${step}`);
    push(path);
    if (queryParams) {
      dispatch(updateQueryParameters({ params: queryParams }));
    }
  };
};

// this function returns the module, stage and step ID to which the passed field belongs to
const getRouteFromFieldUid = ({
  fieldUid,
  stepList,
  stage̵List,
  moduleList,
}) => {
  let stepId, stageId, moduleId;
  _.find(stepList, (step, key) => {
    if (_.includes(step.fields, fieldUid)) {
      stepId = key;
      return true;
    }
  });

  _.find(stage̵List, (stage, key) => {
    const stageSteps = _.get(stage, "steps", {});
    if (_.includes(stageSteps, stepId)) {
      stageId = key;
      return true;
    }
  });

  _.find(moduleList, (module, key) => {
    const moduleStages = _.get(module, "stages", {});
    if (_.includes(moduleStages, stageId)) {
      moduleId = key;
      return true;
    }
  });

  return { stepId, stageId, moduleId };
};

export const getRouteFromFieldUidMemoized = _.memoize(
  getRouteFromFieldUid,
  props => JSON.stringify(props)
);

export const getNextStep = ({ stages, stage_list, current_step }) => {
  return (dispatch, getState) => {
    const current_stage =
      _.find(stages, (stage, index) => {
        return _.indexOf(stage_list[stage].steps, current_step) >= 0;
      }) || _.first(stages);

    const current_stage_object = stage_list[current_stage];
    const currentIndex = _.indexOf(current_stage_object.steps, current_step);
    let nextStep = "";
    if (currentIndex == current_stage_object.steps.length - 1) {
      const currentStageIndex = _.indexOf(stages, current_stage);
      if (currentStageIndex != stages.length - 1) {
        nextStep = stage_list[stages[currentStageIndex + 1]].steps[0];
      } else {
        nextStep = "";
      }
    } else {
      nextStep = current_stage_object.steps[currentIndex + 1];
    }
    return nextStep;
  };
};

export const getPreviousStep = ({ stages, stage_list, current_step }) => {
  return (dispatch, getState) => {
    const current_stage = _.find(stages, (stage, index) => {
      return _.indexOf(stage_list[stage].steps, current_step) >= 0;
    });
    const current_stage_object = stage_list[current_stage];
    const currentIndex = _.indexOf(current_stage_object.steps, current_step);
    let previousStep = "";
    if (currentIndex == 0) {
      const currentStageIndex = _.indexOf(stages, current_stage);
      if (currentStageIndex != 0) {
        const previousStageSteps =
          stage_list[stages[currentStageIndex - 1]].steps;
        previousStep = previousStageSteps[previousStageSteps.length - 1];
      } else {
        previousStep = "";
      }
    } else {
      previousStep = current_stage_object.steps[currentIndex - 1];
    }
    return previousStep;
  };
};

export const isNextStep = ({ stages, stage_list, current_step }) => {
  return (dispatch, getState) => {
    const lastStage = _.last(stages);
    const lastStep = _.last(_.get(stage_list, [lastStage, "steps"]));
    return lastStep != current_step;
  };
};

export const isFirstStep = ({ stages, stage_list, current_step }) => {
  return (dispatch, getState) => {
    const firstStage = _.first(stages);
    const firstStep = _.first(_.get(stage_list, [firstStage, "steps"]));
    return firstStep == current_step;
  };
};

export const goToUnitPlanFeed = () => {
  return (dispatch, getState) => {
    dispatch(
      goToPlatformHomeFeatureRoute({
        route: `unitPlans`,
        navigateType: "replace",
      })
    );
  };
};

export const updateUnitPlanSharing = ({
  courses = { added: [], removed: [] },
  unitPlanId,
  defaultStaffAccess,
  exceptionalCollaborators,
  addedExceptionalCollaborators,
  removedExceptionalCollaborators,
  sections,
  isSharedWithStudents,
  isSharedWithFamilies,
  editGrades = { added: [], removed: [] },
  ownerId,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    dispatch(toggleActionLoading(true));
    try {
      const academicYearId = getSelectedAcademicYearId(getState());
      const collaboratorsFilter = {
        userAcademicYearId: academicYearId,
      };

      await client.mutate({
        mutation: updateUnitPlanSharingMutation,
        variables: {
          unitPlanId: unitPlanId
            ? unitPlanId
            : getState().planner.unitPlanData.unitPlanId,
          updatedBy: userInfo.id,
          defaultStaffAccess,
          courses,
          exceptionalCollaborators,
          addedExceptionalCollaborators,
          removedExceptionalCollaborators,
          sections,
          isSharedWithStudents,
          isSharedWithFamilies,
          editGrades,
          collaboratorsFilter,
          exceptionalCollaboratorsFilter: collaboratorsFilter,
          ownerId,
          skipTitle: ACLStore.can(
            "FeatureFlag:RemoveCourseDetailsFromStaffList"
          ),
        },
      });

      let msg;
      if (!_.isNil(ownerId)) {
        msg = "toastMsgs:entity_shared_and_owner_updated";
      } else {
        msg = "toastMsgs:entity_shared";
      }

      dispatch(
        setToastMsg({
          msg,
          type: "success",
          ...(msg === "toastMsgs:entity_shared" && {
            locale_params: [
              { key: "entity", value: "common:unit_plan", isPlainText: false },
            ],
          }),
        })
      );
    } catch (e) {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    } finally {
      dispatch(toggleActionLoading(false));
    }
  };
};

export const publishUnPublishInSampleUnits = ({
  unitPlanId,
  publishUnitInSampleUnits = null,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    if (!!unitPlanId && !_.isNil(publishUnitInSampleUnits)) {
      const flatUnitPlanFeedQueryVariables = dispatch(
        getFlatUnitPlanFeedQueryVariables()
      );
      await client.mutate({
        mutation: updateUnitPlanMutation,
        variables: {
          unitPlanId,
          updatedBy: userInfo.id,
          publishUnitInSampleUnits,
        },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: getFlatUnitPlanFeedQuery,
            variables: flatUnitPlanFeedQueryVariables,
          },
        ],
      });
    }
  };
};

export const onDateChange = ({ unitPlan, unitPlanId, startDate, endDate }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const userId = userInfo.id;

    const academicYearId = getSelectedAcademicYearId(getState());

    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      organizationId: userInfo.org_id,
      courseId: _.get(getState(), "teacher.selected_class.selected_course", ""),
      academicYearId,
    });

    const updatedUnitPlanDetails = {
      ...unitPlan,
      startDate,
      endDate,
    };

    const responseFilter = getUnitPlanFieldResponseFilter();
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    writeUnitPlanFragment({
      unitPlanId,
      data: updatedUnitPlanDetails,
      responseFilter,
      centralRepoInput,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
      collaboratorsFilter,
    });

    try {
      await client.mutate({
        mutation: updateUnitPlanMutation,
        variables: { unitPlanId, startDate, endDate, updatedBy: userId },
      });
    } catch (e) {
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(
          setToastMsg({ msg: e.graphQLErrors[0].message, notString: true })
        );
      }

      writeUnitPlanFragment({
        unitPlanId,
        data: unitPlan,
        responseFilter,
        centralRepoInput,
        exceptionalCollaboratorsFilter: collaboratorsFilter,
        collaboratorsFilter,
      });
    }
  };
};

export const onDateChangeV2 = ({
  unitPlan,
  unitPlanId,
  startDate,
  endDate,
  classId,
}) => {
  return async (dispatch, getState) => {
    const isLearningCoursesEnabled = getIsLearningCoursesEnabled();
    const userId = getUserInfo().id;
    if (isLearningCoursesEnabled) {
      await handleLearningCourseUnitPlanUpdate({
        unitPlan,
        unitPlanId,
        startDate,
        endDate,
        dispatch,
        userId,
        classId,
      });
    } else {
      await handleCourseUnitPlanUpdate({
        unitPlan,
        unitPlanId,
        startDate,
        endDate,
        dispatch,
        userId,
      });
    }
  };
};

const handleLearningCourseUnitPlanUpdate = async ({
  unitPlan,
  unitPlanId,
  startDate,
  endDate,
  dispatch,
  userId,
  classId,
}) => {
  const queryVariables = dispatch(
    getLearningCourseUnitPlanFeedQueryVariables()
  );
  const classDates = [{ classId, startDate, endDate }];
  const updatedUnitPlanDetails = { ...unitPlan, classDates };
  writeLearningCourseUnitPlanFragment({
    unitPlanId,
    data: updatedUnitPlanDetails,
    queryVariables,
  });

  try {
    await client.mutate({
      mutation: updateUnitPlanMutation,
      variables: { unitPlanId, classDates, updatedBy: userId },
    });
  } catch (e) {
    dispatch(
      setToastMsg(
        e.networkError
          ? "toastMsgs:no_internet_connection"
          : { msg: e.graphQLErrors[0].message, notString: true }
      )
    );
    writeLearningCourseUnitPlanFragment({
      unitPlanId,
      data: unitPlan,
      queryVariables,
    });
  }
};

const handleCourseUnitPlanUpdate = async ({
  unitPlan,
  unitPlanId,
  startDate,
  endDate,
  dispatch,
  userId,
}) => {
  const queryVariables = dispatch(getFlatUnitPlanFeedV2QueryVariables());
  const updatedUnitPlanDetails = { ...unitPlan, startDate, endDate };
  writeUnitPlanV2Fragment({
    unitPlanId,
    data: updatedUnitPlanDetails,
    queryVariables,
  });

  try {
    await client.mutate({
      mutation: updateUnitPlanMutation,
      variables: {
        unitPlanId,
        startDate,
        endDate,
        updatedBy: userId,
      },
    });
  } catch (e) {
    dispatch(
      setToastMsg(
        e.networkError
          ? "toastMsgs:no_internet_connection"
          : { msg: e.graphQLErrors[0].message, notString: true }
      )
    );
    writeUnitPlanV2Fragment({ unitPlanId, data: unitPlan, queryVariables });
  }
};

export const updateUnitPlan = (param = {}) => {
  return async (dispatch, getState) => {
    const {
      valuesToAdd,
      valuesToRemove,
      fieldUID,
      shouldRefetchUnitPlan,
    } = param;
    let { unitPlanId } = param;
    let refetchQueries = false;
    const queriesToRefetch = [];
    if (!unitPlanId && !!getState().planner) {
      unitPlanId = getState().planner.unitPlanData.unitPlanId;
    }

    if (unitPlanId.startsWith("NEW_")) return;
    const userInfo = getUserInfo();
    const selectedCourseId = _.get(
      getState(),
      "teacher.selected_class.selected_course",
      ""
    );

    const academicYearId = getSelectedAcademicYearId(getState());

    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      organizationId: _.get(userInfo, "org_id", ""),
      courseId: selectedCourseId,
      academicYearId,
    });

    const responseFilter = getUnitPlanFieldResponseFilter();
    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const unitPlanDetails = getUnitPlanDetailsFromCache({
      unitPlanId,
      centralRepoInput,
      responseFilter,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
    });

    const unitType = _.get(
      _.find(_.get(unitPlanDetails, "allFields", []), { uid: "unitType" }),
      "value",
      ""
    );
    if (fieldUID === "subjects" && unitType === "ibMYPInterdisciplinary") {
      const isSinglePageUI = isSinglePageAndNewUnitView();
      const hasAddedSubjects = !_.isEmpty(valuesToAdd);

      // Only show loading in old view
      if (!isSinglePageUI) {
        dispatch(toggleActionLoading(true));
      }

      // Refetch data when subjects are added in either:
      // 1. Single page view with added subjects (to update dynamic fields)
      // 2. Always in old view (for backward compatibility)
      if (hasAddedSubjects || !isSinglePageUI) {
        refetchQueries = true;
        queriesToRefetch.push({
          query: getUnitPlanQuery,
          variables: {
            id: unitPlanId,
            centralRepoInput,
            responseFilter,
            collaboratorsFilter,
            exceptionalCollaboratorsFilter: collaboratorsFilter,
          },
        });
      }
    }

    await client.mutate({
      mutation: updateUnitPlanMutation,
      variables: {
        unitPlanId,
        updatedBy: userInfo.id,
        fields: _.omit(param, ["unitPlanId", "fieldUID"]),
      },
      awaitRefetchQueries: refetchQueries,
      refetchQueries: queriesToRefetch,
    });

    //Add/Remove fields on subjects update for Interdisciplinary Unit
    if (fieldUID == "subjects" && unitType == "ibMYPInterdisciplinary") {
      dispatch(toggleActionLoading(false));
    }
  };
};

export const updateUnitPlanDetails = ({
  unitPlanId,
  params = {},
  isCacheRequired = true,
  refetchQueries = false,
  awaitRefetchQueries = false,
  queriesToRefetch = [],
  extraParams = {},
}) => {
  return async (dispatch, getState) => {
    if (unitPlanId.startsWith("NEW_")) return;

    const userInfo = getUserInfo();
    let unitPlanDetails = {};
    const responseFilter = getUnitPlanFieldResponseFilter();
    const academicYearId = getSelectedAcademicYearId(getState());

    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    let centralRepoInput = {};
    if (isCacheRequired) {
      const selectedCourseId = _.get(
        getState(),
        "teacher.selected_class.selected_course",
        ""
      );

      const schoolGrpFilters = getUnitPlanCentralRepoInputAndFilters({
        organizationId: _.get(userInfo, "org_id", ""),
        courseId: selectedCourseId,
        academicYearId,
      });
      centralRepoInput = schoolGrpFilters.centralRepoInput;

      unitPlanDetails = getUnitPlanDetailsFromCache({
        unitPlanId,
        centralRepoInput,
        responseFilter,
        collaboratorsFilter,
        exceptionalCollaboratorsFilter: collaboratorsFilter,
      });
      let updatedUnitPlanDetails = {};
      if (_.has(extraParams, "classDates")) {
        updatedUnitPlanDetails = {
          ...unitPlanDetails,
          classDates: extraParams.classDates,
        };
      } else {
        updatedUnitPlanDetails = {
          ...unitPlanDetails,
          ...params,
        };
      }
      writeUnitPlanFragment({
        unitPlanId,
        data: updatedUnitPlanDetails,
        responseFilter,
        centralRepoInput,
        exceptionalCollaboratorsFilter: collaboratorsFilter,
        collaboratorsFilter,
      });
    }

    try {
      await client.mutate({
        mutation: updateUnitPlanMutation,
        variables: {
          updatedBy: userInfo.id,
          unitPlanId,
          ...params,
        },
        awaitRefetchQueries,
        refetchQueries: refetchQueries ? queriesToRefetch : [],
      });
    } catch (e) {
      console.error(e);
      setTimeout(() => {
        if (isCacheRequired) {
          writeUnitPlanFragment({
            unitPlanId,
            data: unitPlanDetails,
            responseFilter,
            centralRepoInput,
            exceptionalCollaboratorsFilter: collaboratorsFilter,
          });
        }
      });
      if (e.networkError) {
        dispatch(setToastMsg("toastMsgs:no_internet_connection"));
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    }
  };
};

export const updateUnitPlanDetailsV2 = ({
  unitPlanId,
  params = {},
  refetchQueries = false,
  awaitRefetchQueries = false,
  queriesToRefetch = [],
}) => {
  return async (dispatch, getState) => {
    if (unitPlanId.startsWith("NEW_")) return;
    const userId = getUserInfo().id;
    const isLearningCoursesEnabled = getIsLearningCoursesEnabled();
    if (isLearningCoursesEnabled) {
      await handleLearningCourseUnitPlanUpdateV2({
        unitPlanId,
        params,
        dispatch,
        refetchQueries,
        awaitRefetchQueries,
        queriesToRefetch,
        userId,
      });
    } else {
      await handleCourseUnitPlanUpdateV2({
        unitPlanId,
        params,
        dispatch,
        refetchQueries,
        awaitRefetchQueries,
        queriesToRefetch,
        userId,
      });
    }
  };
};

const handleLearningCourseUnitPlanUpdateV2 = async ({
  unitPlanId,
  params,
  dispatch,
  refetchQueries,
  awaitRefetchQueries,
  queriesToRefetch,
  userId,
}) => {
  const queryVariables = dispatch(
    getLearningCourseUnitPlanFeedQueryVariables()
  );
  const data = getLearningCourseUnitPlanFeedFromCache({ ...queryVariables });
  const unitPlanDetails = _.find(
    data.node.unitPlans.edges,
    edge => edge.node.id === unitPlanId
  );
  const updatedUnitPlanDetails = { ...unitPlanDetails.node };

  writeLearningCourseUnitPlanFragment({
    unitPlanId,
    data: updatedUnitPlanDetails,
    queryVariables,
  });

  try {
    await client.mutate({
      mutation: updateUnitPlanMutation,
      variables: { updatedBy: userId, unitPlanId, ...params },
      awaitRefetchQueries,
      refetchQueries: refetchQueries ? queriesToRefetch : [],
    });
  } catch (e) {
    console.error(e);
    writeLearningCourseUnitPlanFragment({
      unitPlanId,
      data: updatedUnitPlanDetails,
      queryVariables,
    });
    dispatch(
      setToastMsg(
        e.networkError
          ? "toastMsgs:no_internet_connection"
          : "toastMsgs:something_went_wrong"
      )
    );
  }
};

const handleCourseUnitPlanUpdateV2 = async ({
  unitPlanId,
  params,
  dispatch,
  refetchQueries,
  awaitRefetchQueries,
  queriesToRefetch,
  userId,
}) => {
  const queryVariables = dispatch(getFlatUnitPlanFeedV2QueryVariables());
  const data = getFlatFeedUnitPlansFromCache({ ...queryVariables });
  const unitPlanDetails = _.find(
    data.node.flatUnitPlans.edges,
    edge => edge.node.id === unitPlanId
  );
  const updatedUnitPlanDetails = {
    ...unitPlanDetails.node,
    // ...params
  };
  writeUnitPlanV2Fragment({
    unitPlanId,
    data: updatedUnitPlanDetails,
    queryVariables,
  });

  try {
    await client.mutate({
      mutation: updateUnitPlanMutation,
      variables: {
        updatedBy: userId,
        unitPlanId,
        ...params,
      },
      awaitRefetchQueries,
      refetchQueries: refetchQueries ? queriesToRefetch : [],
    });
  } catch (e) {
    console.error(e);
    writeUnitPlanV2Fragment({
      unitPlanId,
      data: updatedUnitPlanDetails,
      queryVariables,
    });
    if (e.networkError) {
      dispatch(setToastMsg("toastMsgs:no_internet_connection"));
    } else {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  }
};

export const getUnitPlanDetails = ({ unitPlanId }) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;
    const selectedCourseId = _.get(
      getState(),
      "teacher.selected_class.selected_course",
      ""
    );

    const academicYearId = getSelectedAcademicYearId(getState());

    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      organizationId: organizationId,
      courseId: selectedCourseId,
      academicYearId,
    });

    const responseFilter = getUnitPlanFieldResponseFilter();
    const exceptionalCollaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const result = await client.query({
      query: getUnitPlanQuery,
      variables: {
        id: unitPlanId,
        centralRepoInput,
        responseFilter,
        exceptionalCollaboratorsFilter,
      },
      fetchPolicy: "network-only",
    });
    return result;
  };
};

export const createUnitPlan = ({
  createMode = "teacher",
  grades = [],
  courses = [],
  unitState,
  academicYears = [],
  templateId,
  addedExceptionalCollaborators,
  defaultStaffAccess,
  ownerId,
}) => {
  return async (dispatch, getState) => {
    const userInfo = getUserInfo();
    grades = _.isEmpty(grades)
      ? _.get(getState().teacher, "selected_class.selected_grades", [])
      : grades;
    const unitPlanData = getState().planner.unitPlanData;

    const organizationId = userInfo.org_id;
    const organizationConstants = getOrganizationConstantsFromCache(
      organizationId
    );
    const { leTemplate, assessmentTemplate } = organizationConstants;

    const curriculumProgramId = _.get(
      getState(),
      "platform.currentCurriculumProgram.id",
      ""
    );

    const fields = _.reduce(
      unitPlanData,
      (prevResult, obj, key) => {
        {
          if (obj?.value) {
            prevResult.push({ ...obj, uid: key });
          }
        }
        return prevResult;
      },
      []
    );

    dispatch(initFilterObject());

    const state = getState();
    const courseId = _.get(
      state,
      "teacher.selected_class.selected_course",
      null
    );

    const startDate = _.get(unitPlanData, "startDate.value", "");

    const endDate = _.get(unitPlanData, "endDate.value", "");

    const academicYearId = getSelectedAcademicYearId(getState());

    /** MapleBear specific variables required for flat UnitPlans feed fetching logic */
    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      courseId,
      organizationId,
      academicYearId,
    });
    /* MapleBear end */

    const refetchQueries = courseId
      ? dispatch(getUnitPlanFeedRefetchQueries())
      : [];

    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    try {
      const res = await client.mutate({
        mutation: createUnitPlanMutation,
        variables: {
          input: {
            curriculumProgramId,
            templateId,
            createdBy: userInfo.id,
            ownerId,
            grades,
            fields: fields,
            academicYears,
            leTemplate,
            assessmentTemplate,
            courses,
            startDate,
            endDate,
            state: unitState,
            addedExceptionalCollaborators,
            collaborators: [],
            defaultStaffAccess,
          },
          centralRepoInput,
          showCollaborators: true,
          collaboratorsFilter,
        },
        refetchQueries,
      });
      recordEvent({
        eventName: "Created Unit",
        eventData: { unit_name: _.get(unitPlanData, "title.value", "") },
      });
      if (createMode == "teacher") {
        dispatch(
          setToastMsg({
            msg: "toastMsgs:unit_successfully_action",
            locale_params: [
              { key: "action", value: "toastMsgs:created", isPlainText: false },
            ],
            type: "success",
            position: "toast-bottom-left",
          })
        );
      }
      return _.get(res, "data.planner.createUnitPlan.id", null);
    } catch (err) {
      console.error(err);
      dispatch(
        setToastMsg({
          msg: "toastMsgs:unit_creation_failed",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};
const getValidatedUnitDates = ({ unitPlanData, academicYearSelected }) => {
  let updatedEndDate = _.get(unitPlanData, "endDate.value", "");
  let updatedStartDate = _.get(unitPlanData, "startDate.value", "");

  const { startDate, endDate } = academicYearSelected;
  const minDate = moment(startDate).format("YYYY-MM-DD");
  const maxDate = moment(endDate).format("YYYY-MM-DD");

  if (moment(updatedEndDate).isAfter(moment(maxDate))) {
    updatedEndDate = maxDate;
  }
  if (moment(updatedStartDate).isBefore(moment(minDate))) {
    updatedStartDate = minDate;
  }

  return { updatedStartDate, updatedEndDate };
};

export const updateSyncLockStatusForField = ({
  unitPlanId,
  fieldsData = [],
  shouldMutate = true,
}) => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const userInfo = getUserInfo();
      const selectedCourseId = _.get(
        state,
        "teacher.selected_class.selected_course",
        ""
      );
      const academicYearId = getSelectedAcademicYearId(state);
      const learningCourseId = getSelectedLearningCourseId(state);

      const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
        organizationId: _.get(userInfo, "org_id", ""),
        courseId: selectedCourseId,
        academicYearId,
      });

      const responseFilter = getUnitPlanFieldResponseFilter();
      const collaboratorsFilter = {
        userAcademicYearId: academicYearId,
      };

      const queryVariables = {
        id: unitPlanId,
        lockFilters: {
          learningCourseId,
        },
        syncFilters: {
          learningCourseId,
        },
      };

      // Read cache data from query
      const fieldLockConflictNode = client.readQuery({
        query: getUnitPlanLockAndConflictFieldsQuery,
        variables: queryVariables,
      });

      // Update all fields based on fieldsData array
      let updatedData = fieldLockConflictNode;
      _.forEach(fieldsData, fieldData => {
        const { id: fieldId, isLocked } = fieldData;

        // Find the index of the field with matching fieldId
        const fieldIndex = _.findIndex(
          _.get(updatedData, "node.syncTemplateFields", []),
          ({ item }) => item?.id === fieldId
        );

        if (fieldIndex !== -1) {
          // Update the field using immutability-helper
          updatedData = update(updatedData, {
            node: {
              syncTemplateFields: {
                [fieldIndex]: {
                  item: {
                    lockingInfo: {
                      isLocked: { $set: isLocked },
                    },
                  },
                },
              },
            },
          });
        }
      });

      // Write updated data back to cache
      client.writeQuery({
        query: getUnitPlanLockAndConflictFieldsQuery,
        variables: queryVariables,
        data: updatedData,
      });

      // Fetch unit plan details from cache to check and update UnitPlan's lockingInfo
      const unitPlanDetails = getUnitPlanDetailsFromCache({
        unitPlanId,
        centralRepoInput,
        responseFilter,
        collaboratorsFilter,
        exceptionalCollaboratorsFilter: collaboratorsFilter,
      });

      const isUnitPlannerLocked = _.get(
        unitPlanDetails,
        "lockingInfo.isLocked",
        false
      );

      const allFields = _.map(
        _.filter(
          _.get(updatedData, "node.syncTemplateFields", []),
          data => !_.isNil(_.get(data, "item"))
        ),
        "item"
      );

      // Check if we need to update unit plan lock status
      const allFieldsLocked =
        !_.isEmpty(allFields) &&
        _.every(allFields, field =>
          _.get(field, "lockingInfo.isLocked", false)
        );

      const hasAnyUnlockedField = _.some(
        allFields,
        field => !_.get(field, "lockingInfo.isLocked", false)
      );

      let shouldUpdateUnitPlanLock = false;
      let newUnitPlanLockStatus = isUnitPlannerLocked;

      if (allFieldsLocked && !isUnitPlannerLocked) {
        // All fields are locked and unit plan is not locked
        shouldUpdateUnitPlanLock = true;
        newUnitPlanLockStatus = true;
      } else if (hasAnyUnlockedField && isUnitPlannerLocked) {
        // At least one field is unlocked and unit plan is locked
        shouldUpdateUnitPlanLock = true;
        newUnitPlanLockStatus = false;
      }

      // Update UnitPlan's lockingInfo if needed
      if (shouldUpdateUnitPlanLock) {
        const updatedUnitPlanDetails = update(unitPlanDetails, {
          lockingInfo: {
            isLocked: { $set: newUnitPlanLockStatus },
          },
        });

        writeUnitPlanFragment({
          unitPlanId,
          data: updatedUnitPlanDetails,
          responseFilter,
          centralRepoInput,
          exceptionalCollaboratorsFilter: collaboratorsFilter,
          collaboratorsFilter,
        });
      }

      // Prepare entity locks for mutation
      const entityLocks = _.map(fieldsData, fieldData => ({
        entityId: fieldData.id,
        entityType: "PLANNER_FIELD",
        isLocked: fieldData.isLocked,
      }));

      if (shouldMutate) {
        const variables = {
          input: {
            learningCourseId,
            lockType: "CONTENT_LEVEL_LOCK",
            lockScope: "SELF",
            entityLocks,
          },
        };

        // Call mutation to update lock status in backend
        await client.mutate({
          mutation: updateLockedStateMutation,
          variables,
        });
      }

      if (shouldMutate) {
        const isLocked = _.get(_.first(fieldsData), "isLocked", false);
        dispatch(
          setToastMsg({
            msg: "toastMsgs:action_successfully",
            locale_params: [
              {
                key: "label",
                value: "course:field",
                isPlainText: false,
              },
              {
                key: "action",
                value: isLocked ? "common:locked" : "common:unlocked",
                isPlainText: false,
              },
            ],
            type: "success",
          })
        );
      }
    } catch (e) {
      dispatchError({ dispatch, e });
    }
  };
};

export const getDirectCreateUnitPlanInputData = ({
  grades: _grades = [],
  unitState,
  templateId,
  fields: _fields = [],
  addToTop = false,
}) => {
  return (dispatch, getState) => {
    const state = getState();

    const userInfo = getUserInfo();
    const grades = _.isEmpty(_grades)
      ? _.get(state, "teacher.selected_class.selected_grades", [])
      : _grades;

    const unitPlanData = _.get(state, "planner.unitPlanData", {});

    const organizationId = userInfo.org_id;
    const organizationConstants = getOrganizationConstantsFromCache(
      organizationId
    );
    const { leTemplate, assessmentTemplate } = organizationConstants;

    const curriculumProgramId = _.get(
      state,
      "platform.currentCurriculumProgram.id",
      ""
    );

    const curriculumProgramType = _.get(
      state,
      "platform.currentCurriculumProgram.type",
      ""
    );

    const fields = _.reduce(
      unitPlanData,
      (prevResult, obj, key) => {
        {
          if (obj?.value) {
            prevResult.push({ ...obj, uid: key });
          }
        }
        return prevResult;
      },
      []
    );

    fields.push(..._fields);

    if (
      getIsLearningCoursesEnabled() &&
      curriculumProgramType !== CURRICULUM_TYPE_DP
    ) {
      fields.push({
        value: [],
        uid: "subjectLevel",
      });
    }

    const courseId = _.get(
      state,
      "teacher.selected_class.selected_course",
      null
    );

    let courses;
    if (!_.isEmpty(courseId)) {
      courses = [courseId];
    }
    const academicYearSelected = getSelectedAcademicYear(state);
    const { updatedStartDate, updatedEndDate } = getValidatedUnitDates({
      unitPlanData,
      academicYearSelected,
    });

    const academicYearId = getSelectedAcademicYearId(state);
    const learningCourseId = getSelectedLearningCourseId(state);

    return {
      curriculumProgramId,
      templateId,
      createdBy: userInfo.id,
      grades,
      academicYears: [academicYearId],
      leTemplate,
      assessmentTemplate,
      courses,
      startDate: updatedStartDate,
      endDate: updatedEndDate,
      fields,
      ownerId: userInfo.id,
      state: unitState,
      defaultStaffAccess: "EDIT",
      learningCourseId,
      addToTop,
    };
  };
};

export const directCreateUnitPlan = (args = {}) => {
  return async (dispatch, getState) => {
    const state = getState();
    const learningCourseId = getSelectedLearningCourseId(state);
    const unitPlanData = _.get(state, "planner.unitPlanData", {});

    dispatch(initFilterObject());

    const courseId = _.get(
      state,
      "teacher.selected_class.selected_course",
      null
    );

    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;
    const academicYearId = getSelectedAcademicYearId(state);

    /** MapleBear specific variables required for flat UnitPlans feed fetching logic */
    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      courseId,
      organizationId,
      academicYearId,
    });
    /* MapleBear end */

    const collaboratorsFilter = {
      userAcademicYearId: academicYearId,
    };

    const refetchQueries = learningCourseId
      ? dispatch(getLearningCourseUnitPlanRefetchQueries())
      : courseId && ACLStore.can("FeatureFlag:EnableNewUnitPlanFeed")
      ? dispatch(getUnitPlanFeedV2RefetchQueries())
      : dispatch(getUnitPlanFeedRefetchQueries());

    const input = dispatch(getDirectCreateUnitPlanInputData(args));

    try {
      const res = await client.mutate({
        mutation: createUnitPlanMutationV2,
        variables: {
          input,
          centralRepoInput,
          showCollaborators: learningCourseId ? false : true,
          collaboratorsFilter,
        },
        refetchQueries,
      });
      recordEvent({
        eventName: "Created Unit",
        eventData: { unit_name: _.get(unitPlanData, "title.value", "") },
      });
      return _.get(res, "data.planner.createUnitPlanV2.id", null);
    } catch (err) {
      console.error(err);
      dispatch(
        setToastMsg({
          msg: "toastMsgs:unit_creation_failed",
          type: "warning",
          position: "toast-bottom-left",
        })
      );
    }
  };
};

const setAttachmentDataInCache = ({ fieldDetails, attachment, fieldId }) => {
  const data = {
    ...fieldDetails,
    resolvedMinimalTree: {
      ..._.get(fieldDetails, "resolvedMinimalTree"),
      attachment,
    },
  };

  writeUnitPlanFieldFragment({
    fieldId,
    data,
  });
};

export const updateAttachment = ({ fieldDetails, id, url, type, parentId }) => {
  return async (dispatch, getState) => {
    try {
      const response = await client.mutate({
        mutation: updateAttachmentMutation,
        variables: {
          input: { id, url, type, parentId },
        },
        update: (
          cache,
          {
            data: {
              platform: { updateAttachment },
            },
          }
        ) => {
          const attachment = updateAttachment[0];
          setAttachmentDataInCache({
            fieldDetails,
            attachment,
            fieldId: parentId,
          });
        },
      });
      return _.get(response, "data.platform.updateAttachment", null);
    } catch (e) {
      dispatchError({ dispatch, e });
    }
  };
};

export const deleteAttachment = ({ fieldDetails, id, parentId }) => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: deleteAttachmentMutation,
        variables: {
          attachmentIds: [id],
        },
        update: cache => {
          setAttachmentDataInCache({
            fieldDetails,
            attachment: null,
            fieldId: parentId,
          });
        },
      });
    } catch (e) {
      dispatchError({ dispatch, e });
    }
  };
};

export const createAttachment = ({ url, type, parentId, fieldDetails }) => {
  return async (dispatch, getState) => {
    try {
      const response = await client.mutate({
        mutation: createAttachmentMutation,
        variables: {
          url: url,
          type: type,
          parentType: "PLANNER_FIELD_VIDEO_ATTACHMENT",
          parentId,
        },
        update: (
          cache,
          {
            data: {
              platform: { createAttachment },
            },
          }
        ) => {
          const attachment = createAttachment[0];
          setAttachmentDataInCache({
            fieldDetails,
            attachment: attachment,
            fieldId: parentId,
          });
        },
      });
      return _.get(response, "data.platform.createAttachment[0]", null);
    } catch (e) {
      dispatchError({ dispatch, e });
    }
  };
};

export const sendUnitPlanCollaboratorNotification = ({
  unitPlanId,
  userAcademicYearId,
}) => {
  return async dispatch => {
    try {
      await client.mutate({
        mutation: sendUnitPlanCollaboratorNotificationMutation,
        variables: {
          input: {
            unitPlanId,
            userAcademicYearId,
          },
        },
      });
    } catch (e) {
      console.error("Error sending collaborator notification:", e);
      dispatchError({ dispatch, e });
    }
  };
};

const NON_FETCHED_FIELD_TYPES = [
  "IBSkills",
  "IBBenchmarks",
  "NestedSelectComponent",
  "PlannerElementDataSet",
  "NESTED_CHECKLIST",
];

export const FILTER_REQUIRED_PLANNER_ELEMENT_SETS = [
  "MYP_OBJECTIVES",
  "DP_OBJECTIVES",
  "DP_AIM",
];

/**
 * Generic unit plan field update dispatch
 * Updates value of a single field in the unit plan with only minimal data in params
 * No need to pass unitPlanDetails, template or planner elements
 *
 * Only works for single page planner presently
 * @todo Add support for old unit planner view and custom fields (fieldListV2)
 * @todo Add queries for fields that are not fetched with unit plan (standards, atls, etc)
 *
 * @param {Object} params - params for updating the field
 * @param {string} [params.unitPlanId] - Optional ID of the unit plan to be updated, otherwise current one is updated
 * @param {string} params.fieldUID - UID of the field to be updated
 * @param {any} params.fieldValue - Value to be set for the field
 */
export const updateUnitPlanField = params => {
  return async (dispatch, getState) => {
    const { unitPlanId: _unitPlanId } = params;

    const state = getState();
    const { t: originalT, language } = i18n;

    const t = enhancedT(originalT);

    // STEP 1
    // Get all the required data from state and GQL cache
    // - UnitPlanDetails -> for old value of field
    // - Template -> for field config
    // - PlannerElements -> for all possible field options

    // 1.1 Unit plan details
    const courseId = _.get(state, "teacher.selected_class.selected_course");
    const currentAcademicYearId = getSelectedAcademicYearId(state);

    const unitPlanId =
      _unitPlanId ?? _.get(state, "planner.unitPlanData.unitPlanId", "");

    const userInfo = getUserInfo();
    const organizationId = userInfo.org_id;

    const { centralRepoInput } = getUnitPlanCentralRepoInputAndFilters({
      organizationId,
      courseId,
      academicYearId: currentAcademicYearId,
    });
    const responseFilter = getUnitPlanFieldResponseFilter();
    const collaboratorsFilter = {
      userAcademicYearId: currentAcademicYearId,
    };

    const unitPlanDetails = getUnitPlanDetailsFromCache({
      unitPlanId,
      centralRepoInput,
      responseFilter,
      collaboratorsFilter,
      exceptionalCollaboratorsFilter: collaboratorsFilter,
    });

    const unitPlanAcademicYearsIds = _.get(
      unitPlanDetails,
      "academicYears",
      []
    );
    const academicYearId = _.get(
      unitPlanAcademicYearsIds[0],
      "id",
      currentAcademicYearId
    );

    const unitPlanFields = _.get(unitPlanDetails, "allFields", []);

    const { id: curriculumProgramId = "", type: curriculumType = "" } =
      _.get(state, "platform.currentCurriculumProgram") || {};

    // 1.2 Template
    const templateId = _.get(unitPlanDetails, "templateId", null);

    const template = getPlannerTemplateFromCache(
      getVariablesForLocalisedPlannerTemplates({
        templates: [templateId],
        language,
      })
    );

    const tool = _.get(
      _.find(unitPlanFields, { uid: "measureAssessing" }),
      "value",
      null
    );

    const unitType = _.get(unitPlanDetails, "unitType.value", "");
    const userType = userInfo.user_type;
    const userTags = userInfo.tags;

    const shouldCombine =
      _.get(unitPlanDetails, "assessmentTemplate", "") ==
      "combine_le_assessment";
    const userLevelType = decideUserLevelType({ organizationId, userTags });
    const isImported = _.get(unitPlanDetails, "isImported", false);

    const resolvedSubjectNodes = getArchivedSortedSubjectListMemoized({
      subjectList: _.get(
        unitPlanDetails,
        "subjects.resolvedMinimalTree.subjects",
        []
      ),
    });

    // 1.2.1 Custom fields
    const templateIds = [templateId];
    const fieldListV2Data = getTemplateFieldsFromCache(
      generateTemplateFieldQueryVariables({
        templateIds,
        locale: i18n.language,
        curriculumProgramId,
      })
    );

    const plannerElementSetsItems = state?.platform?.currentPlannerElementSets;

    const plannerElementSets = _.map(plannerElementSetsItems, item => item);

    const updatedTemplate = updateTemplateMemoize({
      t,
      tool,
      template,
      unitType,
      userType,
      courseId,
      shouldCombine,
      curriculumType,
      unitPlanDetails,
      resolvedSubjectNodes,
      userLevelType,
      isImported,
      language, //hack to skip memoization when language is changed
      fieldListV2: getFieldListV2({ data: fieldListV2Data, templateId }),
      isSinglePageAndNewUnitView: isSinglePageAndNewUnitView(),
      plannerElementSets,
    });

    const fieldList = _.get(updatedTemplate, "body.field_list", []);
    const fieldListV2 = _.get(updatedTemplate, "body.fieldListV2", {});

    const plannerElementTypes = getPlannerElementTypesFromTemplate(
      updatedTemplate
    );

    const shouldConvertNonPortedFieldsToPortedFlag = shouldConvertNonPortedFieldsToPorted();
    const unitPlanFieldList = shouldConvertNonPortedFieldsToPortedFlag
      ? fieldListV2
      : fieldList;
    const allPlannerElementTypes = getAllPlannerElementTypesFromFields({
      fieldList: unitPlanFieldList,
    });

    // 1.3.1 getting PlannerElementNodeSetIds

    const curriculumProgram = unitPlanDetails.curriculumProgram;

    const curriculumNodeInterfaceType = _.get(
      curriculumProgram,
      "nodeInterfaceType",
      ""
    );

    const baseCurriculum = getBaseCurriculumProgram(state, {
      currentCurriculumProgramId: curriculumProgramId,
      currentCurriculumProgramType: curriculumType,
    });

    const curriculumPlannerElementNodeSets = getPlannerElementNodeSetIdsOfCurriculumFromCache(
      getPlannerElementNodeSetIdsOfCurriculumVariables({
        curriculumId: curriculumProgramId,
        curriculumNodeInterfaceType,
        allPlannerElementTypes,
      })
    );

    const baseCurriculumPlannerElementNodeSets = baseCurriculum
      ? getPlannerElementNodeSetIdsOfCurriculumFromCache(
          getPlannerElementNodeSetIdsOfCurriculumVariables({
            curriculumId: _.get(baseCurriculum, "id", ""),
            curriculumNodeInterfaceType: _.get(
              baseCurriculum,
              "nodeInterfaceType",
              ""
            ),
            allPlannerElementTypes,
          })
        )
      : [];

    const plannerElementNodeSets = getMergedPlannerElementNodeSets(
      curriculumPlannerElementNodeSets,
      baseCurriculumPlannerElementNodeSets
    );

    // 1.3.2 All  planner element node sets

    const selectedSubjectLevels = _.get(
      _.find(unitPlanFields, {
        uid: "subjectLevel",
      }),
      "value",
      []
    );
    const subjects = unitPlanDetails.subjects;

    const subjectDependentElementTypes = _.intersection(
      plannerElementTypes,
      FILTER_REQUIRED_PLANNER_ELEMENT_SETS
    );

    const additionalTypesToRemove = _.concat(
      _.difference(allPlannerElementTypes, plannerElementTypes),
      subjectDependentElementTypes
    );

    // Filter subject-independent element node sets (excludes certain types)
    const filteredPlannerElementNodeSets = getFilteredPlannerElementNodeSets({
      plannerElementNodeSets,
      additionalTypesToRemove,
    });

    const subjectIndependentPlannerElementNodeSets = getPlannerElementNodeSetsFromIdsFromCache(
      getPlannerElementNodeSetsFromIdsVariables({
        plannerElementNodeSets: filteredPlannerElementNodeSets,
        academicYearId,
      })
    );

    // Filter subject-dependent element node sets (excludes certain types)
    const filteredSubjectDependentNodeSets = _.filter(
      getFilteredPlannerElementNodeSets({
        plannerElementNodeSets,
      }),
      nodeSet => {
        return _.includes(subjectDependentElementTypes, nodeSet.type);
      }
    );

    const subjectDependentPlannerElementNodeFilters = getPlannerElementNodeFiltersMemoized(
      {
        selectedSubjectLevels,
        subjects,
        plannerElementTypes: subjectDependentElementTypes,
      }
    );

    const subjectDependentPlannerElementNodeSets = getPlannerElementNodeSetsFromIdsFromCache(
      getPlannerElementNodeSetsFromIdsVariables({
        plannerElementNodeSets: filteredSubjectDependentNodeSets,
        plannerElementNodeFilters: subjectDependentPlannerElementNodeFilters,
      })
    );

    // Merge all planner element node sets with deep merge to preserve fragments
    // First merge: plannerElementNodeSets + subjectIndependentPlannerElementNodeSets
    const mergedWithSubjectIndependent = getMergedPlannerElementNodeSets(
      plannerElementNodeSets,
      subjectIndependentPlannerElementNodeSets
    );

    // Second merge: result + subjectDependentPlannerElementNodeSets
    const allPlannerElementNodeSets = getMergedPlannerElementNodeSets(
      mergedWithSubjectIndependent,
      subjectDependentPlannerElementNodeSets
    );

    // STEP 2
    // Generate params for updating the field
    // - Old value -> for hasAddRemoveValues field
    // - Options -> for optimistic cache update

    const { fieldUID, fieldValue } = params;
    const isPorted = _.has(fieldListV2, fieldUID);

    const fieldTemplateObj = isPorted
      ? _.get(fieldListV2, fieldUID, {})
      : _.get(fieldList, fieldUID, {});
    const fieldObj = _.find(unitPlanFields, { uid: fieldUID });

    if (!fieldObj) return;

    const id = fieldObj.id;
    const value = {
      id,
      value: fieldValue,
      portalType: "PLANNER",
    };
    const oldValue = _.get(fieldObj, "value", []);

    const options = getPlannerFieldOptions({
      fieldKey: fieldUID,
      unitPlanFields,
      readOnly: false,
      plannerElementNodeSets: allPlannerElementNodeSets,
      field_list: fieldList,
      grades: _.get(unitPlanDetails, "grades", []),
      t,
    });

    const hasAddRemoveValues = _.get(
      fieldTemplateObj,
      "config.hasAddRemoveValues",
      false
    );

    // STEP 3
    // Update in cache and call mutation

    // some fields are not writable in cache directly
    // because we fetch their data in a modal
    const fieldType = isPorted
      ? _.get(fieldTemplateObj, "uiType.value", "")
      : _.get(fieldTemplateObj, "type", "");

    const isFieldDirectlyWriteableInCache = !_.includes(
      NON_FETCHED_FIELD_TYPES,
      fieldType
    );

    if (isFieldDirectlyWriteableInCache) {
      dispatch(
        updateUnitPlanInCache({
          fieldUID,
          params: value,
          fieldObj,
          extraParams: { nodes: options },
          fieldTemplateObj,
        })
      );
    }

    await dispatch(
      updateUnitPlan(
        getPlannerFieldMutationParams({
          id,
          oldValue,
          hasAddRemoveValues,
          newValue: fieldValue,
          fieldUID,
        })
      )
    );

    // TODO: change this approach later to fetch data
    // and write in cache
    if (!isFieldDirectlyWriteableInCache) {
      const responseFilter = getUnitPlanFieldResponseFilter();
      dispatch(
        getPlannerFieldsOfNode({
          type: "UNIT_PLAN",
          uids: [fieldUID],
          id: unitPlanId,
          responseFilter,
        })
      );
    }
  };
};

// export const createUnitPlan = ({
//   successCallBack,
//   failureCallBack,
//   collaborators = [],
//   createMode = "teacher",
//   grades = [],
//   courses = [],
//   curriculumType = "IB_PYP",
//   unitState,
//   academicYears = [],
// }) => {
//   return async (dispatch, getState) => {
//     const unitPlanData = getState().planner.unitPlanData;

//     const organizationId = getState().login.userInfo.org_id;
//     const organizationConstants = getOrganizationConstantsFromCache(
//       organizationId
//     );
//     const { leTemplate, assessmentTemplate } = organizationConstants;

//     const curriculumProgramId = _.get(
//       _.find(getState().platform.organizationCurriculumPrograms, {
//         type: curriculumType,
//       }),
//       "id",
//       ""
//     );

//     const fields = _.reduce(
//       unitPlanData,
//       (prevResult, obj, key) => {
//         //  if (!_.includes(fixedUnitPlanIds, key))
//         {
//           if (obj?.value) {
//             prevResult.push({ ...obj, uid: key });
//           }
//         }
//         return prevResult;
//       },
//       []
//     );

//     dispatch(initFilterObject());

//     const state = getState();
//     const staffId = state.login.userInfo.id;
//     const courseId = getState().teacher.selected_class.selected_course;
//     const type = "COURSE";
//     const filters = _.get(state, "unitPlans.filters", {
//       searchText: "",
//       isShowPrivate: true,
//     });

//     const staffData = getUnitPlanFeedFromCache({
//       id: courseId,
//       filters,
//       groupBy: "UNIT_TYPE",
//       type,
//       showCollaborators: true,
//     });

//     const edges = _.get(staffData, `unitPlans.edges`, []);

//     //const collaborators = state.planner.unitPlanData.collaborators;
//     // const newUnitPlan = {
//     //   id: `${generateRandomId()} loading`,
//     //   collaborators: {
//     //     totalCount: 0,
//     //     edges: [],
//     //     __typename: "UnitPlanCollaboratorConnection"
//     //   },
//     //   title: {
//     //     id: "temp",
//     //     value: unitPlanData.title.value,
//     //     __typename: "PlannerField"
//     //   },
//     //   theme: { id: "loading", value: "Loading...", __typename: "PlannerField" },
//     //   image: {
//     //     id: "image",
//     //     value: _.get(unitPlanData, "image.value", ""),
//     //     __typename: "PlannerField"
//     //   },
//     //   duration: { id: "", value: "", __typename: "PlannerField" },
//     //   subjects: { id: "", value: [], __typename: "PlannerField" },
//     //   resourceLibrary: {
//     //     leCount: 0,
//     //     assessmentCount: 0,
//     //     __typename: "ResourceLibraryConnection"
//     //   },
//     //   templateId: _.get(unitPlanData.selectTemplate, "value", ""),
//     //   __typename: "UnitPlan"
//     // };

//     // console.log(staffId, grade, staffData);

//     const totalCount = _.get(staffData, "unitPlans.totalCount", 0);
//     let e = null;

//     const templateId = _.get(unitPlanData, "plannerType.value", "");

//     const startDate = _.get(unitPlanData, "startDate.value", "");

//     const endDate = _.get(unitPlanData, "endDate.value", "");

//     /*In DP we need to add generic tags which includes subject level and response language
//     genric tags is a object which includes the common tags such as response language of subject and
//     it also includes the subject levels
//     By sending generic tags from here we are defining that this unit is mapped with this particular subject levels and response language
//     */
//     const genericTags = [
//       ..._.get(unitPlanData, "responseLanguage.value", []),
//       ..._.get(unitPlanData, "subjectLevel.value", []),
//     ];

//     const {
//       startDate: startDateAcademicYear,
//       endDate: endDateAcademicYear,
//     } = getCurrentAcademicYear({
//       organizationId,
//     });

//     const isMYP = _.isEqual(curriculumType, "IB_MYP");

//     try {
//       await client.mutate({
//         mutation: createUnitPlanMutation,
//         variables: {
//           curriculumProgramId,
//           templateId: templateId,
//           createdBy: state.login.userInfo.id,
//           grades,
//           fields: fields,
//           collaborators: collaborators,
//           academicYears,
//           leTemplate,
//           assessmentTemplate,
//           courses,
//           startDate,
//           endDate,
//           state: unitState,
//           showCollaborators: true,
//           ...(!_.isEmpty(genericTags) && { genericTags }),
//         },
//         refetchQueries: courseId
//           ? [
//               {
//                 query: getYearlySchedulerQuery,
//                 variables: {
//                   isMYP,
//                   id: courseId,
//                   endDate: endDateAcademicYear,
//                   startDate: startDateAcademicYear,
//                   searchText: filters.searchText,
//                   detailedUnitPlan: false,
//                   uids: FIELD_UID_CURRICULUM_MAPPING[curriculumType],
//                 },
//               },
//               _.includes([CURRICULUM_TYPE_DP], curriculumType) && {
//                 query: getFlatUnitPlansQuery,
//                 variables: {
//                   id: courseId,
//                   uids: [],
//                   orderByDirection: "ASC",
//                   orderBy: "START_DATE",
//                   filters: { courses: [courseId] },
//                 },
//               },
//             ]
//           : [],
//         // optimisticResponse: {
//         //   __typename: "Mutation",
//         //   planner: {
//         //     __typename: "PlannerMutations",
//         //     createUnitPlan: newUnitPlan
//         //   }
//         // },
//         update: (
//           cache,
//           {
//             data: {
//               planner: { createUnitPlan },
//             },
//           }
//         ) => {
//           let updatedStaffData;
//           if (createMode == "teacher") {
//             const fieldValue = _.get(createUnitPlan, "unitType.value", "");
//             const edgeIndex = _.findIndex(edges, item => {
//               return item.fieldValue === fieldValue;
//             });

//             if (edgeIndex < 0) {
//               updatedStaffData = update(staffData, {
//                 unitPlans: {
//                   totalCount: { $set: totalCount + 1 },
//                   edges: {
//                     $push: [
//                       {
//                         __typename: "GroupedUnitPlanEdge",
//                         fieldValue: fieldValue,
//                         type: "UNIT_TYPE",
//                         node: [createUnitPlan],
//                       },
//                     ],
//                   },
//                 },
//               });
//             } else {
//               updatedStaffData = update(staffData, {
//                 unitPlans: {
//                   totalCount: { $set: totalCount + 1 },
//                   edges: {
//                     [edgeIndex]: {
//                       node: {
//                         $splice: [[0, 0, createUnitPlan]],
//                       },
//                     },
//                   },
//                 },
//               });
//             }
//             setTimeout(() => {
//               writeUnitPlanFeedInCache({
//                 id: courseId,
//                 type,
//                 filters,
//                 groupBy: "UNIT_TYPE",
//                 data: updatedStaffData,
//               });
//             });
//             dispatch(updateGradeUnitPlanCount({ count: 1 }));
//           }

//           successCallBack(createUnitPlan);
//         },
//       });
//       EventTracker.recordEvent({
//         eventName: "Created Unit",
//         eventData: { unit_name: _.get(unitPlanData, "title.value", "") },
//       });
//     } catch (err) {
//       console.error(err);
//       failureCallBack();
//       e = err;
//       if (createMode == "teacher") {
//         setTimeout(() => {
//           writeUnitPlanFeedInCache({
//             id: courseId,
//             type,
//             filters,
//             groupBy: "UNIT_TYPE",
//             data: staffData,
//           });
//         });
//       }
//     }
//     if (e) {
//       console.error(e);
//       dispatch(
//         setToastMsg({
//           msg: "toastMsgs:unit_creation_failed",
//           type: "warning",
//           position: "toast-bottom-left",
//         })
//       );
//     } else {
//       if (createMode == "teacher") {
//         dispatch(
//           setToastMsg({
//             msg: "toastMsgs:unit_successfully_action",
//             locale_params: [
//               { key: "action", value: "toastMsgs:created", isPlainText: false },
//             ],
//             type: "success",
//             position: "toast-bottom-left",
//           })
//         );
//       }
//     }
//   };
// };
const REDUCER_HANDLERS = {
  [CHANGE_CURRENT_STEP]: (state, action) => {
    // console.log(state, action);
    return update(state, {
      current_step: { $set: action.data },

      current_module_step:
        state.module_id && action.data
          ? { [state.module_id]: { $set: action.data } }
          : {},
    });
  },
  [UPDATE_EVIDENCE_FILTERS]: (state, action) => {
    const params = action.data;

    state = update(state, {
      evidenceFilters: { $set: params },
    });

    return state;
  },
  [CHANGE_CURRENT_MODULE_STEP]: (state, action) => {
    return update(state, {
      current_module_step: { [action.data.key]: { $set: action.data.value } },
    });
  },
  [SET_VIEW_STEP]: (state, action) => {
    return update(state, { current_view_step: { $set: action.data } });
  },
  [RESET_SCROLL_CURRENT_MODULE_STEP]: (state, action) => {
    return update(state, {
      current_module_step: { $set: {} },
      middlePaneScrollTop: { $set: {} },
    });
  },

  [SET_MIDDLE_PANE_SCROLL_TOP]: (state, action) => {
    return update(state, {
      middlePaneScrollTop: { [action.data.key]: { $set: action.data.value } },
    });
  },

  [SET_MODULE_ID]: (state, action) => {
    return update(state, { module_id: { $set: action.data } });
  },
  [RESET_UNIT_PLAN_DATA]: (state, action) => {
    const unitPlanData = _.cloneDeep(initialState.unitPlanData);
    unitPlanData.startDate = {
      value: moment().format("YYYY-MM-DD"),
    };
    unitPlanData.endDate = {
      value: moment().add(6, "week").format("YYYY-MM-DD"),
    };
    return update(state, {
      unitPlanData: { $set: _.cloneDeep(unitPlanData) },
    });
  },

  [UPDATE_EVIDENCE_SEARCH_TEXT]: (state, action) => {
    return update(state, { evidenceSearchText: { $set: action.data } });
  },
  [UPDATE_UNIT_PLAN_IN_REDUX]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, { unitPlanData: { [key]: { $set: params[key] } } });
    });
    return state;
  },
  [UPDATE_COMMENT]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        createComment: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [UPDATE_RESPONSES]: (state, action) => {
    const params = action.data;
    Object.keys(params).map((key, index) => {
      state = update(state, {
        responses: { [key]: { $set: params[key] } },
      });
    });
    return state;
  },
  [TOGGLE_ACTION_LOADING]: (state, action) => {
    return update(state, {
      isActionLoading: { $set: action.data },
    });
  },
};

const initialState = {
  current_step: null,
  module_id: null,
  library_scrolled_to_bottom: false,
  current_module_step: {},
  middlePaneScrollTop: {},
  isActionLoading: false,
  unitPlanData: {
    unitType: null,
    templateId: "",
    selectedTemplateId: null,
    unitPlanId: generateRandomId(),
    startDate: { value: moment().format("YYYY-MM-DD") },
    endDate: {
      value: moment().add(6, "week").format("YYYY-MM-DD"),
    },
    duration: { value: { week: 6 } },
    lois: { value: [{ id: generateRandomId(), value: "" }] },
    collaborators: [],
    title: null,
  },
  responses: {},
  evidenceFilters: [],
  evidenceSearchText: "",
  collaboratorSearchText: "",
  createComment: {
    message: "",
  },
  current_view_step: "",
};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

export const FIELD_PROPERTY_MAPPING = {
  type: "uiType",
  "config.label": "label",
  "config.subtext": "subtext",
  "config.allowComment": "allowComment",
  "config.allowHelpText": "allowHelpText",
  "config.isRequired": "isRequired",
  "config.isRequiredToCreateUnit": "isRequiredToCreateUnit",
  "config.showReflection": "showReflection",
  "config.promptsConfig.label": "promptsLabel",
  "config.promptsConfig.showPrompts": "showPrompts",
  "config.placeHolder": "placeholder",
  "config.isLearningGoal": "isLearningGoal",
  "config.emptyText": "emptyText",
  "config.fieldTypeConfig.emptyEditText": "fieldTypeConfigEmptyEditText",
  "config.fieldTypeConfig.hasSelection": "fieldTypeConfigHasSelection",
  "config.fieldTypeConfig.isGroupedOptions": "fieldTypeConfigIsGroupedOptions",
  "config.fieldTypeConfig.options": "fieldTypeConfigOptions",
  "config.fieldTypeConfig.showSubtextUnderInfo":
    "fieldTypeConfigShowSubtextUnderInfo",
  "config.icon": "icon",
  "config.isDisciplinary": "isDisciplinary",
  "config.plannerElementConfig.type": "plannerElementConfigType",
  "config.fieldTypeConfig.isUpdateActionsAllowed":
    "fieldTypeConfigIsUpdateActionsAllowed",
  "config.fieldTypeConfig.totalColumns": "fieldTypeConfigTotalColumns",
  subField: "subField",
  "config.fieldTypeConfig.showTextBoxOnSelect":
    "fieldTypeConfigShowTextBoxOnSelect",
  "config.fieldTypeConfig.isDependentField": "fieldTypeConfigIsDependentField",
  "config.fieldTypeConfig.shouldFilterParentNodesOnUpdate":
    "fieldTypeConfigShouldFilterParentNodesOnUpdate",
  "config.hasAddRemoveValues": "hasAddRemoveValues",
  "config.options": "options",
  "config.type": "plannerElementSetId",
  dynamicSubject: "dynamicSubject",
  "config.plannerElementConfig": "plannerElementObj",
  "config.fieldTypeConfig.allowMultiSelect": "fieldTypeConfigAllowMultiSelect",
  "config.fieldTypeConfig.showListItemNumber":
    "fieldTypeConfigShowListItemNumber",
  "config.dependentFieldEmptyText": "dependentFieldEmptyText",
  "config.lockFieldForSchoolGroups": "lockFieldForSchoolGroups",
};

export const convertNonPortedToPorted = ({
  template,
  templateId,
  plannerElementSets,
}) => {
  const allowedPlannerElementSets = ["PYP_PLANNER_ELEMENT", "PLANNER_ELEMENT"];
  const field_list = _.get(template, "body.field_list", []);

  const templateFields = _.map(field_list, (fieldObj, fieldKey) => {
    const clonedField = _.cloneDeep(fieldObj);
    clonedField.config.allowComment = clonedField.config.allowComment ?? true;
    clonedField.config.allowHelpText = clonedField.config.allowHelpText ?? true;
    const portedFieldObj = {
      id: generateRandomId(),
      uid: fieldKey,
      config: [],
    };

    _.forEach(FIELD_PROPERTY_MAPPING, (portedKey, originalKey) => {
      let value = _.get(clonedField, originalKey, null);

      if (portedKey === "plannerElementSetId") {
        if (!_.includes(allowedPlannerElementSets, value)) {
          value = null;
        } else {
          const plannerElementType = _.get(
            _.get(clonedField, "config.plannerElementConfig", {}),
            "type",
            null
          );

          const plannerElementSetId = _.get(
            _.find(plannerElementSets, { type: plannerElementType }, null),
            "id",
            null
          );

          value = plannerElementSetId;
        }
      }

      if (portedKey === "fieldTypeConfigAllowMultiSelect") {
        const multi = _.get(fieldObj, "config.fieldTypeConfig.multi", false);
        value = value || multi;
      }

      if (value !== null) {
        portedFieldObj.config.push({
          id: generateRandomId(),
          globalFieldProperty: {
            id: generateRandomId(),
            property: portedKey,
          },
          parentId: null,
          children: [],
          values: [
            {
              id: generateRandomId(),
              value,
              configLevel: {
                id: null,
                type: "DEFAULT",
              },
            },
          ],
        });
      }
    });

    return { node: portedFieldObj };
  });

  return generateFieldListFromTemplateFields({
    templateFields,
    templateId,
  });
};

export const shouldConvertNonPortedFieldsToPorted = () => {
  return ACLStore.can("FeatureFlag:EnablePortedFieldsForUnitTemplate");
};

export const isDisplayNewFieldsInOldViewEnabled = () => {
  return ACLStore.can("FeatureFlag:EnablePortedFieldsForUnitTemplate");
};
